const routesData = [
  // Existing ports
  {
    lat: 50.9481,
    lng: 1.8583,
    name: "Calais",
    description:
      "Hauptfährhafen in Nordfrankreich mit Verbindungen nach Dover und anderen britischen Häfen",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 51.1279,
    lng: 1.3134,
    name: "Dover",
    description:
      "Wichtigster britischer Fährhafen mit Verbindungen nach Calais und Dünkirchen",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 54.3213,
    lng: 10.1348,
    name: "Kiel",
    description:
      "Deutscher Ostseehafen mit Verbindungen nach Skandinavien, besonders nach Oslo",
    country: "Deutschland",
    type: "port",
  },
  {
    lat: 59.9139,
    lng: 10.7522,
    name: "Oslo",
    description:
      "Norwegischer Hauptstadthafen mit Fährverbindungen nach Deutschland und Dänemark",
    country: "Norwegen",
    type: "port",
  },
  {
    lat: 51.9225,
    lng: 4.4792,
    name: "Rotterdam",
    description:
      "Größter Hafen Europas mit Fährverbindungen nach Großbritannien",
    country: "Niederlande",
    type: "port",
  },
  {
    lat: 51.0347,
    lng: 2.3773,
    name: "Dünkirchen",
    description: "Französischer Nordseehafen mit Fährverbindungen nach Dover",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 53.7442,
    lng: -0.3373,
    name: "Hull",
    description:
      "Britischer Nordseehafen mit Fährverbindungen nach Rotterdam und anderen europäischen Häfen",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 50.7919,
    lng: 0.0366,
    name: "Newhaven",
    description:
      "Englischer Kanalhafen mit Fährverbindungen nach Dieppe in Frankreich",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 49.9267,
    lng: 1.0842,
    name: "Dieppe",
    description: "Französischer Kanalhafen mit Fährverbindungen nach Newhaven",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 51.0814,
    lng: 1.1799,
    name: "Folkestone",
    description: "Englischer Kanalhafen mit Fährverbindungen nach Calais",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 50.8058,
    lng: -1.0872,
    name: "Portsmouth",
    description:
      "Wichtiger englischer Südküstenhafen mit Verbindungen nach Frankreich und Spanien",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 50.6667,
    lng: -1.2833,
    name: "Fishbourne",
    description: "Hafen auf der Isle of Wight mit Verbindungen nach Portsmouth",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 50.7155,
    lng: -1.9872,
    name: "Poole",
    description:
      "Englischer Südküstenhafen mit Verbindungen nach Frankreich und Spanien",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 43.2627,
    lng: -2.9253,
    name: "Bilbao",
    description:
      "Spanischer Nordküstenhafen mit Fährverbindungen nach England und Irland",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 43.4623,
    lng: -3.8054,
    name: "Santander",
    description:
      "Spanischer Nordküstenhafen mit regelmäßigen Verbindungen nach Portsmouth und Plymouth",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 50.3755,
    lng: -4.1427,
    name: "Plymouth",
    description:
      "Englischer Südwesthafen mit Fährverbindungen nach Spanien und Frankreich",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 49.6337,
    lng: -1.6206,
    name: "Cherbourg",
    description:
      "Französischer Normannischer Hafen mit Verbindungen nach England und Irland",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 49.4938,
    lng: 0.1079,
    name: "Le Havre",
    description:
      "Wichtiger französischer Atlantikhafen mit Fährverbindungen nach Portsmouth",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 51.9469,
    lng: 1.2833,
    name: "Harwich",
    description: "Englischer Nordseehafen mit Verbindungen nach Holland",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 51.9775,
    lng: 4.1297,
    name: "Hoek van Holland",
    description:
      "Niederländischer Nordseehafen mit Fährverbindungen nach Harwich und Killingholme",
    country: "Niederlande",
    type: "port",
  },
  {
    lat: 51.3333,
    lng: 3.2,
    name: "Zeebrugge",
    description: "Belgischer Nordseehafen mit Verbindungen nach England",
    country: "Belgien",
    type: "port",
  },
  {
    lat: 51.4614,
    lng: 0.3553,
    name: "Tilbury",
    description: "Englischer Themsehafen mit Fährverbindungen nach Zeebrugge",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 51.4833,
    lng: 0.2333,
    name: "Purfleet",
    description: "Englischer Themsehafen mit Verbindungen nach Belgien",
    country: "Vereinigtes Königreich",
    type: "port",
  },

  // New Scottish ports
  {
    lat: 57.1497,
    lng: -2.0943,
    name: "Aberdeen",
    description:
      "Schottischer Nordseehafen mit Verbindungen zu den Orkney- und Shetlandinseln",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 58.9811,
    lng: -2.9597,
    name: "Kirkwall",
    description:
      "Haupthafen der Orkney-Inseln mit Fährverbindungen nach Aberdeen",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 58.6097,
    lng: -3.5406,
    name: "Scrabster",
    description: "Schottischer Hafen mit Verbindungen zu den Orkney-Inseln",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 58.9667,
    lng: -3.2958,
    name: "Stromness",
    description: "Hafen auf den Orkney-Inseln mit Verbindungen nach Scrabster",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 56.4133,
    lng: -5.4711,
    name: "Oban",
    description: "Wichtiger schottischer Fährhafen für die Hebriden",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 57.1667,
    lng: -7.3,
    name: "Lochboisdale",
    description: "Hafen auf South Uist mit Verbindungen nach Oban",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 57.4833,
    lng: -6.5667,
    name: "Uig",
    description:
      "Hafen auf der Isle of Skye mit Verbindungen zu den Äußeren Hebriden",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 57.9,
    lng: -6.8,
    name: "Tarbert (Harris)",
    description: "Hafen auf Harris mit Verbindungen nach Skye",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 56.95,
    lng: -7.4833,
    name: "Castlebay",
    description: "Hafen auf Barra mit Verbindungen nach Oban",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 56.6167,
    lng: -6.55,
    name: "Coll",
    description: "Hafen auf der Insel Coll mit Verbindungen nach Oban",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 56.4833,
    lng: -6.75,
    name: "Tiree",
    description: "Hafen auf der Insel Tiree mit Verbindungen nach Oban",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 56.4725,
    lng: -5.7044,
    name: "Craignure",
    description: "Hafen auf der Isle of Mull mit Verbindungen nach Oban",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 55.6275,
    lng: -5.5508,
    name: "Kennacraig",
    description: "Schottischer Hafen mit Verbindungen nach Islay",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 55.6597,
    lng: -6.2047,
    name: "Port Ellen",
    description: "Hafen auf Islay mit Verbindungen nach Kennacraig",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 56.0708,
    lng: -6.2444,
    name: "Colonsay",
    description: "Inselhafen mit Verbindungen nach Oban",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 55.6833,
    lng: -5.75,
    name: "Gigha",
    description: "Kleiner Inselhafen mit lokalen Fährverbindungen",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 55.7,
    lng: -5.5833,
    name: "Tayinloan",
    description: "Schottischer Festlandhafen mit Verbindungen nach Gigha",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 60.1547,
    lng: -1.1494,
    name: "Lerwick",
    description: "Haupthafen der Shetlandinseln mit Verbindungen nach Aberdeen",
    country: "Vereinigtes Königreich",
    type: "port",
  },

  // English ports
  {
    lat: 53.5833,
    lng: -0.2667,
    name: "Killingholme",
    description: "Englischer Nordseehafen mit Verbindungen nach Holland",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 54.61,
    lng: -1.155,
    name: "Teesport",
    description:
      "Großer Nordseehafen mit Fährverbindungen nach Belgien und Niederlande",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 53.6333,
    lng: -0.2,
    name: "Immingham",
    description:
      "Englischer Nordseehafen mit Verbindungen nach Deutschland und Dänemark",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 53.4084,
    lng: -2.9916,
    name: "Liverpool",
    description:
      "Wichtiger englischer Westküstenhafen mit Verbindungen nach Irland",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 54.0689,
    lng: -2.8686,
    name: "Heysham",
    description:
      "Englischer Hafen mit Verbindungen nach Isle of Man und Irland",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 54.9783,
    lng: -1.6178,
    name: "Newcastle",
    description: "Englischer Nordseehafen mit Verbindungen nach Holland",
    country: "Vereinigtes Königreich",
    type: "port",
  },
  {
    lat: 51.9617,
    lng: 1.295,
    name: "Felixstowe",
    description: "Großer englischer Containerhafen mit Fährverbindungen",
    country: "Vereinigtes Königreich",
    type: "port",
  },

  // Scottish mainland ports
  {
    lat: 55.0167,
    lng: -5.0333,
    name: "Cairnryan",
    description: "Schottischer Hafen mit Verbindungen nach Nordirland",
    country: "Vereinigtes Königreich",
    type: "port",
  },

  // Welsh ports
  {
    lat: 51.9983,
    lng: -4.9853,
    name: "Fishguard",
    description: "Walisischer Hafen mit Verbindungen nach Irland",
    country: "Wales",
    type: "port",
  },
  {
    lat: 51.6739,
    lng: -4.9164,
    name: "Pembroke",
    description: "Walisischer Hafen mit Fährverbindungen nach Irland",
    country: "Wales",
    type: "port",
  },
  {
    lat: 53.3094,
    lng: -4.6336,
    name: "Holyhead",
    description: "Wichtigster walisischer Fährhafen nach Irland",
    country: "Wales",
    type: "port",
  },

  // Irish ports
  {
    lat: 53.3498,
    lng: -6.2603,
    name: "Dublin",
    description:
      "Irischer Hauptstadthafen mit Verbindungen nach England und Wales",
    country: "Irland",
    type: "port",
  },
  {
    lat: 54.85,
    lng: -5.7944,
    name: "Larne",
    description: "Nordirischer Hafen mit Verbindungen nach Schottland",
    country: "Nordirland",
    type: "port",
  },
  {
    lat: 54.5964,
    lng: -5.93,
    name: "Belfast",
    description:
      "Haupthafen Nordirlands mit Verbindungen nach Schottland und England",
    country: "Nordirland",
    type: "port",
  },
  {
    lat: 52.2486,
    lng: -6.3397,
    name: "Rosslare",
    description:
      "Irischer Südosthafen mit Verbindungen nach Wales, Frankreich und Spanien",
    country: "Irland",
    type: "port",
  },
  {
    lat: 54.35,
    lng: -6.0667,
    name: "Warrenpoint",
    description: "Nordirischer Hafen mit Fährverbindungen",
    country: "Nordirland",
    type: "port",
  },

  // Isle of Man
  {
    lat: 54.15,
    lng: -4.4833,
    name: "Douglas",
    description: "Haupthafen der Isle of Man mit Verbindungen nach England",
    country: "Isle of Man",
    type: "port",
  },

  // German ports
  {
    lat: 53.8656,
    lng: 10.6869,
    name: "Lübeck",
    description:
      "Deutscher Ostseehafen mit Verbindungen nach Skandinavien und Baltikum",
    country: "Deutschland",
    type: "port",
  },
  {
    lat: 53.9575,
    lng: 10.8786,
    name: "Travemünde",
    description: "Deutscher Ostseehafen mit Fährverbindungen nach Skandinavien",
    country: "Deutschland",
    type: "port",
  },
  {
    lat: 54.0924,
    lng: 12.0991,
    name: "Rostock",
    description:
      "Großer deutscher Ostseehafen mit Verbindungen nach Skandinavien",
    country: "Deutschland",
    type: "port",
  },
  {
    lat: 53.8667,
    lng: 8.6833,
    name: "Cuxhaven",
    description: "Deutscher Nordseehafen mit Fährverbindungen nach England",
    country: "Deutschland",
    type: "port",
  },
  {
    lat: 54.5089,
    lng: 13.6114,
    name: "Sassnitz",
    description:
      "Deutscher Ostseehafen auf Rügen mit Verbindungen nach Bornholm",
    country: "Deutschland",
    type: "port",
  },
  {
    lat: 54.4789,
    lng: 11.1581,
    name: "Puttgarden",
    description:
      "Deutscher Fährhafen auf Fehmarn mit Verbindungen nach Dänemark",
    country: "Deutschland",
    type: "port",
  },

  // Dutch ports
  {
    lat: 52.4608,
    lng: 4.6103,
    name: "IJmuiden",
    description: "Niederländischer Nordseehafen mit Verbindungen nach England",
    country: "Niederlande",
    type: "port",
  },

  // Danish ports
  {
    lat: 55.4244,
    lng: 8.1153,
    name: "Esbjerg",
    description: "Dänischer Nordseehafen mit Verbindungen nach England",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 57.5936,
    lng: 9.9633,
    name: "Hirtshals",
    description:
      "Dänischer Nordseehafen mit Verbindungen nach Norwegen und Island",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 55.6761,
    lng: 12.5683,
    name: "Kopenhagen",
    description:
      "Dänische Hauptstadt mit Fährverbindungen nach Norwegen und Schweden",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 55.0333,
    lng: 14.7,
    name: "Rønne",
    description: "Haupthafen von Bornholm mit Verbindungen zum Festland",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 54.6333,
    lng: 11.3833,
    name: "Rødby",
    description: "Dänischer Fährhafen mit Verbindungen nach Deutschland",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 55.3333,
    lng: 10.8333,
    name: "Nyborg",
    description: "Dänischer Hafen an der Großen Belt-Brücke",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 55.3333,
    lng: 11.1333,
    name: "Korsør",
    description: "Dänischer Hafen an der Großen Belt-Brücke",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 56.2667,
    lng: 10.9167,
    name: "Grenaa",
    description: "Dänischer Ostjütlandhafen mit Verbindungen nach Schweden",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 57.4333,
    lng: 10.5333,
    name: "Frederikshavn",
    description:
      "Dänischer Nordjütlandhafen mit Verbindungen nach Schweden und Norwegen",
    country: "Dänemark",
    type: "port",
  },
  {
    lat: 55.4833,
    lng: 12.0833,
    name: "Køge",
    description:
      "Dänischer Hafen südlich von Kopenhagen mit Verbindungen nach Bornholm",
    country: "Dänemark",
    type: "port",
  },

  // Estonian ports
  {
    lat: 59.45,
    lng: 24.05,
    name: "Paldiski",
    description: "Estnischer Hafen mit Verbindungen nach Deutschland",
    country: "Estland",
    type: "port",
  },
  {
    lat: 59.437,
    lng: 24.7536,
    name: "Tallinn",
    description: "Estnische Hauptstadt mit Fährverbindungen nach Finnland",
    country: "Estland",
    type: "port",
  },

  // Latvian ports
  {
    lat: 56.5167,
    lng: 21.0167,
    name: "Liepāja",
    description: "Lettischer Ostseehafen mit Fährverbindungen nach Deutschland",
    country: "Lettland",
    type: "port",
  },
  {
    lat: 57.3956,
    lng: 21.5619,
    name: "Ventspils",
    description:
      "Lettischer Hafen mit Verbindungen nach Schweden und Deutschland",
    country: "Lettland",
    type: "port",
  },

  // Lithuanian ports
  {
    lat: 55.7069,
    lng: 21.1175,
    name: "Klaipėda",
    description:
      "Litauischer Ostseehafen mit Fährverbindungen nach Deutschland und Schweden",
    country: "Litauen",
    type: "port",
  },

  // Finnish ports
  {
    lat: 60.1699,
    lng: 24.9384,
    name: "Helsinki",
    description:
      "Finnische Hauptstadt mit Fährverbindungen nach Estland, Schweden und Deutschland",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 63.095,
    lng: 21.6164,
    name: "Vaasa",
    description: "Finnischer Westküstenhafen mit Verbindungen nach Schweden",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 60.4667,
    lng: 22.0,
    name: "Naantali",
    description: "Finnischer Hafen nahe Turku mit Verbindungen nach Schweden",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 60.4518,
    lng: 22.2666,
    name: "Turku",
    description:
      "Wichtiger finnischer Fährhafen mit Verbindungen nach Schweden",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 65.7367,
    lng: 24.5656,
    name: "Kemi",
    description: "Finnischer Nordhafen mit Verbindungen nach Deutschland",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 65.0142,
    lng: 25.4719,
    name: "Oulu",
    description: "Finnischer Nordhafen mit Fährverbindungen nach Deutschland",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 61.1272,
    lng: 21.5031,
    name: "Rauma",
    description: "Finnischer Westküstenhafen mit Verbindungen nach Deutschland",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 60.4667,
    lng: 26.95,
    name: "Kotka",
    description: "Finnischer Südosthafen mit Fährverbindungen",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 59.8231,
    lng: 23.9597,
    name: "Hanko",
    description: "Finnischer Südwesthafen mit Verbindungen nach Deutschland",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 60.8,
    lng: 21.4,
    name: "Uusikaupunki",
    description: "Finnischer Hafen mit Verbindungen nach Deutschland",
    country: "Finnland",
    type: "port",
  },
  {
    lat: 60.1,
    lng: 19.9333,
    name: "Mariehamn",
    description: "Haupthafen der Åland-Inseln zwischen Schweden und Finnland",
    country: "Finnland",
    type: "port",
  },

  // Swedish ports
  {
    lat: 63.8258,
    lng: 20.263,
    name: "Umeå",
    description: "Schwedischer Nordhafen mit Verbindungen nach Finnland",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 59.3639,
    lng: 19.0772,
    name: "Kapellskär",
    description:
      "Schwedischer Hafen nördlich von Stockholm mit Finnlandverbindungen",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 59.3293,
    lng: 18.0686,
    name: "Stockholm",
    description:
      "Schwedische Hauptstadt mit Fährverbindungen nach Finnland und Baltikum",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 58.5986,
    lng: 17.0078,
    name: "Nynäshamn",
    description:
      "Schwedischer Hafen südlich von Stockholm mit Verbindungen nach Baltikum",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 56.1642,
    lng: 15.5886,
    name: "Oskarshamn",
    description: "Schwedischer Ostküstenhafen mit Verbindungen nach Gotland",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 57.6333,
    lng: 18.3,
    name: "Visby",
    description:
      "Haupthafen von Gotland mit Verbindungen zum schwedischen Festland",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 56.1628,
    lng: 15.5869,
    name: "Karlshamn",
    description: "Schwedischer Südosthafen mit Verbindungen nach Litauen",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 56.1621,
    lng: 15.5869,
    name: "Karlskrona",
    description: "Schwedischer Marinehafen mit Fährverbindungen nach Polen",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 55.375,
    lng: 13.1569,
    name: "Ystad",
    description:
      "Schwedischer Südhafen mit Verbindungen nach Polen und Bornholm",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 55.3761,
    lng: 13.1608,
    name: "Trelleborg",
    description:
      "Schwedischer Südhafen mit Verbindungen nach Deutschland und Polen",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 55.605,
    lng: 13.0038,
    name: "Malmö",
    description:
      "Schwedische Großstadt mit Fährverbindungen und Öresundbrücke nach Dänemark",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 57.2667,
    lng: 12.3333,
    name: "Varberg",
    description: "Schwedischer Westküstenhafen mit Verbindungen nach Dänemark",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 57.7089,
    lng: 11.9746,
    name: "Göteborg",
    description:
      "Schwedens zweitgrößte Stadt mit Fährverbindungen nach Dänemark",
    country: "Schweden",
    type: "port",
  },
  {
    lat: 56.8883,
    lng: 14.8086,
    name: "Bergkvara",
    description: "Schwedischer Kleinhafen mit lokalen Verbindungen",
    country: "Schweden",
    type: "port",
  },

  // Norwegian ports
  {
    lat: 60.3913,
    lng: 5.3221,
    name: "Bergen",
    description: "Norwegischer Westküstenhafen mit Verbindungen nach Dänemark",
    country: "Norwegen",
    type: "port",
  },
  {
    lat: 58.97,
    lng: 5.7331,
    name: "Stavanger",
    description: "Norwegischer Südwesthafen mit Fährverbindungen nach Dänemark",
    country: "Norwegen",
    type: "port",
  },
  {
    lat: 58.145,
    lng: 8.0059,
    name: "Kristiansand",
    description: "Norwegischer Südhafen mit Verbindungen nach Dänemark",
    country: "Norwegen",
    type: "port",
  },
  {
    lat: 59.05,
    lng: 9.75,
    name: "Larvik",
    description: "Norwegischer Hafen mit Fährverbindungen nach Dänemark",
    country: "Norwegen",
    type: "port",
  },
  {
    lat: 59.1333,
    lng: 9.6667,
    name: "Langesund",
    description: "Norwegischer Südküstenhafen mit Verbindungen nach Dänemark",
    country: "Norwegen",
    type: "port",
  },

  // Polish ports
  {
    lat: 54.352,
    lng: 18.6466,
    name: "Gdańsk",
    description:
      "Großer polnischer Ostseehafen mit Fährverbindungen nach Schweden",
    country: "Polen",
    type: "port",
  },
  {
    lat: 54.5189,
    lng: 18.5305,
    name: "Gdynia",
    description: "Polnischer Ostseehafen mit Verbindungen nach Schweden",
    country: "Polen",
    type: "port",
  },
  {
    lat: 53.9175,
    lng: 14.2444,
    name: "Świnoujście",
    description:
      "Polnischer Ostseehafen mit Verbindungen nach Schweden und Dänemark",
    country: "Polen",
    type: "port",
  },

  // Spanish ports (Mediterranean & Atlantic)
  {
    lat: 39.4699,
    lng: -0.3763,
    name: "Valencia",
    description:
      "Großer spanischer Mittelmeerhafen mit Verbindungen zu den Balearen",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 41.3851,
    lng: 2.1734,
    name: "Barcelona",
    description:
      "Wichtiger spanischer Mittelmeerhafen mit Verbindungen zu Balearen und Nordafrika",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 39.5696,
    lng: 2.6502,
    name: "Palma",
    description:
      "Haupthafen Mallorcas mit Verbindungen zum spanischen Festland",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 38.9067,
    lng: 1.4206,
    name: "Ibiza",
    description: "Inselhafen mit Verbindungen nach Barcelona und Valencia",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 40.0,
    lng: 4.0667,
    name: "Ciutadella",
    description: "Hafen auf Menorca mit Verbindungen nach Barcelona",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 39.85,
    lng: 3.1333,
    name: "Alcúdia",
    description: "Nordhafen Mallorcas mit Verbindungen nach Barcelona",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 36.5333,
    lng: -6.3,
    name: "Cádiz",
    description:
      "Spanischer Atlantikhafen mit Verbindungen zu den Kanarischen Inseln",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 28.1,
    lng: -15.4167,
    name: "Las Palmas",
    description: "Haupthafen Gran Canarias",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 28.9667,
    lng: -13.55,
    name: "Arrecife",
    description: "Haupthafen Lanzarotes",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 28.4682,
    lng: -16.2546,
    name: "Santa Cruz de Tenerife",
    description: "Haupthafen Teneriffas",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 36.1408,
    lng: -5.453,
    name: "Algeciras",
    description: "Spanischer Südhafen mit Verbindungen nach Marokko und Ceuta",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 36.7167,
    lng: -4.4167,
    name: "Málaga",
    description: "Spanischer Mittelmeerhafen mit Verbindungen nach Melilla",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 36.7167,
    lng: -3.5333,
    name: "Motril",
    description: "Spanischer Südküstenhafen mit Verbindungen nach Melilla",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 36.0128,
    lng: -5.6058,
    name: "Tarifa",
    description: "Südlichster Hafen Europas mit Verbindungen nach Marokko",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 36.8381,
    lng: -2.4597,
    name: "Almería",
    description: "Spanischer Mittelmeerhafen mit Verbindungen nach Nordafrika",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 35.2919,
    lng: -2.938,
    name: "Melilla",
    description: "Spanische Exklave in Nordafrika mit Fährverbindungen",
    country: "Spanien",
    type: "port",
  },
  {
    lat: 35.8894,
    lng: -5.3213,
    name: "Ceuta",
    description:
      "Spanische Exklave in Nordafrika mit Verbindungen nach Algeciras",
    country: "Spanien",
    type: "port",
  },

  // French ports (Mediterranean & Atlantic)
  {
    lat: 48.75,
    lng: -3.4667,
    name: "Roscoff",
    description: "Französischer Bretagne-Hafen mit Verbindungen nach England",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 43.2965,
    lng: 5.3698,
    name: "Marseille",
    description:
      "Großer französischer Mittelmeerhafen mit Verbindungen nach Korsika und Nordafrika",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 43.1242,
    lng: 5.928,
    name: "Toulon",
    description: "Französischer Mittelmeerhafen mit Verbindungen nach Korsika",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 43.6951,
    lng: 7.2758,
    name: "Nizza",
    description: "Französischer Rivierahafen mit Verbindungen nach Korsika",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 43.4014,
    lng: 3.6964,
    name: "Sète",
    description:
      "Französischer Mittelmeerhafen mit Verbindungen nach Nordafrika",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 42.7019,
    lng: 9.4508,
    name: "Bastia",
    description:
      "Haupthafen Korsikas mit Verbindungen nach Frankreich und Italien",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 42.6333,
    lng: 8.9333,
    name: "Ile Rousse",
    description: "Korsischer Nordhafen mit Verbindungen nach Frankreich",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 41.927,
    lng: 8.7386,
    name: "Ajaccio",
    description: "Hauptstadt Korsikas mit Fährverbindungen nach Frankreich",
    country: "Frankreich",
    type: "port",
  },
  {
    lat: 41.5908,
    lng: 9.2806,
    name: "Porto Vecchio",
    description: "Südkorsischer Hafen mit Verbindungen nach Frankreich",
    country: "Frankreich",
    type: "port",
  },

  // Italian ports
  {
    lat: 40.8518,
    lng: 14.2681,
    name: "Neapel",
    description:
      "Großer italienischer Südhafen mit Verbindungen nach Sizilien und Sardinien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 44.4056,
    lng: 8.9463,
    name: "Genua",
    description:
      "Wichtiger italienischer Nordwesthafen mit Verbindungen nach Sardinien, Sizilien und Nordafrika",
    country: "Italien",
    type: "port",
  },
  {
    lat: 38.1157,
    lng: 13.3615,
    name: "Palermo",
    description:
      "Haupthafen Siziliens mit Verbindungen nach Festlanditalien und Nordafrika",
    country: "Italien",
    type: "port",
  },
  {
    lat: 37.5079,
    lng: 15.083,
    name: "Catania",
    description: "Sizilianischer Ostküstenhafen mit Fährverbindungen",
    country: "Italien",
    type: "port",
  },
  {
    lat: 40.6824,
    lng: 14.7681,
    name: "Salerno",
    description: "Italienischer Südhafen mit Verbindungen nach Sizilien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 36.9167,
    lng: 14.7333,
    name: "Pozzallo",
    description: "Sizilianischer Südhafen mit Verbindungen nach Malta",
    country: "Italien",
    type: "port",
  },
  {
    lat: 43.5511,
    lng: 10.3047,
    name: "Livorno",
    description:
      "Toskanischer Hafen mit Verbindungen nach Sardinien, Korsika und Sizilien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 42.0117,
    lng: 11.725,
    name: "Civitavecchia",
    description: "Hafen nahe Rom mit Verbindungen nach Sardinien und Sizilien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 40.8333,
    lng: 8.4167,
    name: "Porto Torres",
    description: "Nordsardinischer Hafen mit Verbindungen nach Festlanditalien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 40.9167,
    lng: 9.5,
    name: "Olbia",
    description: "Nordsardinischer Hafen mit Verbindungen nach Festlanditalien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 39.2167,
    lng: 9.1167,
    name: "Cagliari",
    description: "Hauptstadt Sardiniens mit Fährverbindungen",
    country: "Italien",
    type: "port",
  },
  {
    lat: 39.9333,
    lng: 9.6833,
    name: "Arbatax",
    description: "Ostsardinischer Hafen mit Verbindungen nach Festlanditalien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 44.3106,
    lng: 8.4689,
    name: "Savona",
    description: "Italienischer Nordwesthafen mit Verbindungen nach Korsika",
    country: "Italien",
    type: "port",
  },
  {
    lat: 43.7228,
    lng: 13.5063,
    name: "Ancona",
    description:
      "Italienischer Adriahafen mit Verbindungen nach Griechenland und Kroatien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 41.1171,
    lng: 16.8719,
    name: "Bari",
    description:
      "Italienischer Südosthafen mit Verbindungen nach Griechenland und Albanien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 45.4408,
    lng: 12.3155,
    name: "Venedig",
    description:
      "Italienischer Nordosthafen mit Verbindungen nach Griechenland",
    country: "Italien",
    type: "port",
  },
  {
    lat: 40.6384,
    lng: 17.947,
    name: "Brindisi",
    description:
      "Italienischer Südosthafen mit Verbindungen nach Griechenland und Albanien",
    country: "Italien",
    type: "port",
  },
  {
    lat: 38.1938,
    lng: 15.554,
    name: "Messina",
    description: "Sizilianischer Hafen mit kurzer Fährverbindung zum Festland",
    country: "Italien",
    type: "port",
  },
  {
    lat: 38.1897,
    lng: 15.6422,
    name: "Villa San Giovanni",
    description: "Italienischer Festlandhafen gegenüber von Messina",
    country: "Italien",
    type: "port",
  },
  {
    lat: 45.4642,
    lng: 9.19,
    name: "Triest",
    description: "Italienischer Nordosthafen mit Verbindungen zur Türkei",
    country: "Italien",
    type: "port",
  },

  // Greek ports
  {
    lat: 37.9471,
    lng: 23.6458,
    name: "Piräus",
    description:
      "Haupthafen Athens mit Verbindungen zu den griechischen Inseln",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 36.4341,
    lng: 28.225,
    name: "Rhodos",
    description: "Inselhafen mit Verbindungen nach Athen",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 35.5138,
    lng: 24.018,
    name: "Chania",
    description: "Kretischer Nordhafen mit Verbindungen nach Piräus",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 35.3387,
    lng: 25.1442,
    name: "Iraklio",
    description: "Haupthafen Kretas mit Verbindungen nach Athen",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 39.6242,
    lng: 19.9217,
    name: "Korfu",
    description: "Ionische Insel mit Verbindungen nach Italien",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 39.665,
    lng: 20.8537,
    name: "Igoumenitsa",
    description: "Griechischer Westhafen mit Verbindungen nach Italien",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 38.2466,
    lng: 21.7346,
    name: "Patras",
    description:
      "Wichtiger griechischer Westhafen mit Verbindungen nach Italien",
    country: "Griechenland",
    type: "port",
  },
  {
    lat: 37.9667,
    lng: 23.9667,
    name: "Lavrio",
    description: "Attischer Hafen mit Verbindungen nach Zypern und Israel",
    country: "Griechenland",
    type: "port",
  },

  // Croatian ports
  {
    lat: 43.5081,
    lng: 16.4402,
    name: "Split",
    description: "Großer kroatischer Adriahafen mit Verbindungen nach Italien",
    country: "Kroatien",
    type: "port",
  },

  // Albanian ports
  {
    lat: 41.3231,
    lng: 19.4569,
    name: "Durrës",
    description: "Haupthafen Albaniens mit Verbindungen nach Italien",
    country: "Albanien",
    type: "port",
  },

  // Malta
  {
    lat: 35.8989,
    lng: 14.5146,
    name: "Valletta",
    description: "Haupthafen Maltas mit Verbindungen nach Italien",
    country: "Malta",
    type: "port",
  },

  // Turkish ports
  {
    lat: 41.0082,
    lng: 28.9784,
    name: "Istanbul",
    description: "Türkische Metropole mit Fährverbindungen",
    country: "Türkei",
    type: "port",
  },
  {
    lat: 36.8,
    lng: 34.6333,
    name: "Mersin",
    description: "Türkischer Mittelmeerhafen mit Verbindungen nach Italien",
    country: "Türkei",
    type: "port",
  },
  {
    lat: 41.0333,
    lng: 41.2,
    name: "Karasu",
    description: "Türkischer Schwarzmeerhafen mit Verbindungen nach Ukraine",
    country: "Türkei",
    type: "port",
  },
  {
    lat: 40.8667,
    lng: 29.2167,
    name: "Pendik",
    description: "Istanbuler Hafenvorort mit Fährverbindungen nach Frankreich",
    country: "Türkei",
    type: "port",
  },

  // Georgian ports
  {
    lat: 42.15,
    lng: 41.6333,
    name: "Batumi",
    description:
      "Georgischer Schwarzmeerhafen mit Verbindungen nach Ukraine und Bulgarien",
    country: "Georgien",
    type: "port",
  },
  {
    lat: 42.1667,
    lng: 41.6667,
    name: "Poti",
    description: "Georgischer Schwarzmeerhafen mit Fährverbindungen",
    country: "Georgien",
    type: "port",
  },

  // Ukrainian ports
  {
    lat: 46.4825,
    lng: 30.7233,
    name: "Chornomorsk",
    description:
      "Ukrainischer Schwarzmeerhafen mit Verbindungen nach Georgien und Türkei",
    country: "Ukraine",
    type: "port",
  },

  // Bulgarian ports
  {
    lat: 42.5047,
    lng: 27.4626,
    name: "Burgas",
    description: "Bulgarischer Schwarzmeerhafen mit Verbindungen nach Georgien",
    country: "Bulgarien",
    type: "port",
  },
  {
    lat: 43.2047,
    lng: 27.9161,
    name: "Varna",
    description:
      "Bulgarischer Schwarzmeerhafen mit Fährverbindungen nach Georgien",
    country: "Bulgarien",
    type: "port",
  },

  // Cypriot ports
  {
    lat: 34.6721,
    lng: 33.0437,
    name: "Limassol",
    description: "Haupthafen Zyperns mit Verbindungen nach Griechenland",
    country: "Zypern",
    type: "port",
  },

  // Israeli ports
  {
    lat: 32.8156,
    lng: 34.9892,
    name: "Haifa",
    description: "Israelischer Haupthafen mit Verbindungen nach Griechenland",
    country: "Israel",
    type: "port",
  },

  // Moroccan ports
  {
    lat: 35.7595,
    lng: -5.8337,
    name: "Tanger",
    description:
      "Marokkanischer Nordhafen mit intensiven Verbindungen nach Spanien",
    country: "Marokko",
    type: "port",
  },
  {
    lat: 35.1681,
    lng: -2.9333,
    name: "Nador",
    description: "Marokkanischer Mittelmeerhafen mit Verbindungen nach Spanien",
    country: "Marokko",
    type: "port",
  },

  // Algerian ports
  {
    lat: 35.6969,
    lng: -0.6331,
    name: "Oran",
    description: "Algerischer Mittelmeerhafen mit Verbindungen nach Spanien",
    country: "Algerien",
    type: "port",
  },
  {
    lat: 35.9317,
    lng: 0.09,
    name: "Mostaganem",
    description: "Algerischer Mittelmeerhafen mit Verbindungen nach Valencia",
    country: "Algerien",
    type: "port",
  },
  {
    lat: 35.1,
    lng: -1.45,
    name: "Ghazaouet",
    description: "Algerischer Westhafen mit Verbindungen nach Almería",
    country: "Algerien",
    type: "port",
  },

  // Tunisian ports
  {
    lat: 36.8065,
    lng: 10.1815,
    name: "Tunis",
    description: "Tunesischer Haupthafen mit Verbindungen nach Italien",
    country: "Tunesien",
    type: "port",
  },

  // Icelandic ports
  {
    lat: 65.2627,
    lng: -14.0145,
    name: "Seyðisfjörður",
    description: "Isländischer Osthafen mit Verbindungen nach Dänemark",
    country: "Island",
    type: "port",
  },

  // Latvian additional
  {
    lat: 56.9496,
    lng: 24.1052,
    name: "Riga",
    description: "Lettische Hauptstadt mit Fährverbindungen nach Schweden",
    country: "Lettland",
    type: "port",
  },
];

// Beispiel GeoJSON mit MultiLineString für Fährrouten
const ferryRoutesGeoJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        name: "Calais-Dover Route",
        operator: "P&O Ferries",
        duration: "90 minutes",
        frequency: "Alle 2 Stunden",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.8583, 50.9481], // Calais (lng, lat)
            [1.3134, 51.1279], // Dover (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kiel-Oslo Route",
        operator: "Color Line",
        duration: "20 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.1348, 54.3213], // Kiel (lng, lat)
            [10.7522, 59.9139], // Oslo (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dünkirchen-Dover Route",
        operator: "DFDS Seaways",
        duration: "2 Stunden",
        frequency: "4 mal täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.3773, 51.0347], // Dünkirchen (lng, lat)
            [1.3134, 51.1279], // Dover (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Hull-Rotterdam Route",
        operator: "P&O Ferries",
        duration: "11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.3373, 53.7442], // Hull (lng, lat)
            [4.4792, 51.9225], // Rotterdam (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Newhaven-Dieppe Route",
        operator: "DFDS Seaways",
        duration: "4 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [0.0366, 50.7919], // Newhaven (lng, lat)
            [1.0842, 49.9267], // Dieppe (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Calais-Folkestone Route",
        operator: "Eurotunnel",
        duration: "35 Minuten",
        frequency: "Alle 30 Minuten",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.8583, 50.9481], // Calais (lng, lat)
            [1.1799, 51.0814], // Folkestone (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Portsmouth-Fishbourne Route",
        operator: "Wightlink",
        duration: "45 Minuten",
        frequency: "Jede Stunde",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.0872, 50.8058], // Portsmouth (lng, lat)
            [-1.2833, 50.6667], // Fishbourne (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Poole-Bilbao Route",
        operator: "Brittany Ferries",
        duration: "24-32 Stunden",
        frequency: "2 mal pro Woche",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.9872, 50.7155], // Poole (lng, lat)
            [-2.9253, 43.2627], // Bilbao (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Santander-Portsmouth Route",
        operator: "Brittany Ferries",
        duration: "24 Stunden",
        frequency: "Mehrmals pro Woche",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.8054, 43.4623], // Santander (lng, lat)
            [-1.0872, 50.8058], // Portsmouth (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Santander-Plymouth Route",
        operator: "Brittany Ferries",
        duration: "20 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.8054, 43.4623], // Santander (lng, lat)
            [-4.1427, 50.3755], // Plymouth (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bilbao-Portsmouth Route",
        operator: "Brittany Ferries",
        duration: "24-32 Stunden",
        frequency: "2 mal pro Woche",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9253, 43.2627], // Bilbao (lng, lat)
            [-1.0872, 50.8058], // Portsmouth (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Poole-Cherbourg Route",
        operator: "Brittany Ferries",
        duration: "4-5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.9872, 50.7155], // Poole (lng, lat)
            [-1.6206, 49.6337], // Cherbourg (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Le Havre-Portsmouth Route",
        operator: "Brittany Ferries",
        duration: "5-8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [0.1079, 49.4938], // Le Havre (lng, lat)
            [-1.0872, 50.8058], // Portsmouth (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Harwich-Hoek van Holland Route",
        operator: "Stena Line",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.2833, 51.9469], // Harwich (lng, lat)
            [4.1297, 51.9775], // Hoek van Holland (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zeebrugge-Tilbury Route",
        operator: "Cobelfret Ferries",
        duration: "12 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.2, 51.3333], // Zeebrugge (lng, lat)
            [0.3553, 51.4614], // Tilbury (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zeebrugge-Purfleet Route",
        operator: "DFDS Seaways",
        duration: "12-14 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.2, 51.3333], // Zeebrugge (lng, lat)
            [0.2333, 51.4833], // Purfleet (lng, lat)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Aberdeen-Kirkwall Route",
        operator: "NorthLink Ferries",
        duration: "6 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.0943, 57.1497], // Aberdeen
            [-2.9597, 58.9811], // Kirkwall
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Scrabster-Stromness Route",
        operator: "NorthLink Ferries",
        duration: "90 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.5406, 58.6097], // Scrabster
            [-3.2958, 58.9667], // Stromness
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oban-Lochboisdale Route",
        operator: "CalMac Ferries",
        duration: "5-7 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.4711, 56.4133], // Oban
            [-7.3, 57.1667], // Lochboisdale
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Uig-Tarbert Route",
        operator: "CalMac Ferries",
        duration: "1-2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.5667, 57.4833], // Uig
            [-6.8, 57.9], // Tarbert (Harris)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oban-Castlebay Route",
        operator: "CalMac Ferries",
        duration: "5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.4711, 56.4133], // Oban
            [-7.4833, 56.95], // Castlebay
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oban-Coll & Tiree Route",
        operator: "CalMac Ferries",
        duration: "3-4 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.4711, 56.4133], // Oban
            [-6.55, 56.6167], // Coll
            [-6.75, 56.4833], // Tiree
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oban-Craignure Route",
        operator: "CalMac Ferries",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.4711, 56.4133], // Oban
            [-5.7044, 56.4725], // Craignure
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kennacraig-Port Ellen Route",
        operator: "CalMac Ferries",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.5508, 55.6275], // Kennacraig
            [-6.2047, 55.6597], // Port Ellen
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oban-Colonsay Route",
        operator: "CalMac Ferries",
        duration: "2-3 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.4711, 56.4133], // Oban
            [-6.2444, 56.0708], // Colonsay
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Tayinloan-Gigha Route",
        operator: "CalMac Ferries",
        duration: "20 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.5833, 55.7], // Tayinloan
            [-5.75, 55.6833], // Gigha
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Aberdeen-Lerwick Route",
        operator: "NorthLink Ferries",
        duration: "12-14 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.0943, 57.1497], // Aberdeen
            [-1.1494, 60.1547], // Lerwick
          ],
        ],
      },
    },

    // North Sea Routes
    {
      type: "Feature",
      properties: {
        name: "Zeebrugge-Hull Route",
        operator: "P&O Ferries",
        duration: "13 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.2, 51.3333], // Zeebrugge
            [-0.3373, 53.7442], // Hull
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Killingholme-Hoek van Holland Route",
        operator: "Stena Line",
        duration: "12 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.2667, 53.5833], // Killingholme
            [4.1297, 51.9775], // Hoek van Holland
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Teesport-Zeebrugge Route",
        operator: "DFDS",
        duration: "15 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.155, 54.61], // Teesport
            [3.2, 51.3333], // Zeebrugge
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Teesport-Rotterdam Route",
        operator: "DFDS",
        duration: "14 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.155, 54.61], // Teesport
            [4.4792, 51.9225], // Rotterdam
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Immingham-Cuxhaven Route",
        operator: "DFDS",
        duration: "16 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.2, 53.6333], // Immingham
            [8.6833, 53.8667], // Cuxhaven
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Immingham-Esbjerg Route",
        operator: "DFDS",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.2, 53.6333], // Immingham
            [8.1153, 55.4244], // Esbjerg
          ],
        ],
      },
    },

    // Irish Sea Routes
    {
      type: "Feature",
      properties: {
        name: "Dublin-Liverpool Route",
        operator: "P&O Ferries",
        duration: "7-8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.2603, 53.3498], // Dublin
            [-2.9916, 53.4084], // Liverpool
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Douglas-Heysham Route",
        operator: "Steam Packet Company",
        duration: "3-4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-4.4833, 54.15], // Douglas
            [-2.8686, 54.0689], // Heysham
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Larne-Cairnryan Route",
        operator: "P&O Ferries",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.7944, 54.85], // Larne
            [-5.0333, 55.0167], // Cairnryan
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Newcastle-IJmuiden Route",
        operator: "DFDS",
        duration: "16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.6178, 54.9783], // Newcastle
            [4.6103, 52.4608], // IJmuiden
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Heysham-Warrenpoint Route",
        operator: "Stena Line",
        duration: "3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.8686, 54.0689], // Heysham
            [-6.0667, 54.35], // Warrenpoint
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dublin-Heysham Route",
        operator: "Stena Line",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.2603, 53.3498], // Dublin
            [-2.8686, 54.0689], // Heysham
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Belfast-Cairnryan Route",
        operator: "Stena Line",
        duration: "2 Stunden 15 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.93, 54.5964], // Belfast
            [-5.0333, 55.0167], // Cairnryan
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rosslare-Cherbourg Route",
        operator: "Stena Line",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3397, 52.2486], // Rosslare
            [-1.6206, 49.6337], // Cherbourg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dublin-Cherbourg Route",
        operator: "Irish Ferries",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.2603, 53.3498], // Dublin
            [-1.6206, 49.6337], // Cherbourg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Belfast-Liverpool Route",
        operator: "Stena Line",
        duration: "8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.93, 54.5964], // Belfast
            [-2.9916, 53.4084], // Liverpool
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rosslare-Fishguard Route",
        operator: "Stena Line",
        duration: "3-4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3397, 52.2486], // Rosslare
            [-4.9853, 51.9983], // Fishguard
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rosslare-Pembroke Route",
        operator: "Irish Ferries",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3397, 52.2486], // Rosslare
            [-4.9164, 51.6739], // Pembroke
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dublin-Rotterdam Route",
        operator: "P&O Ferries",
        duration: "15 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.2603, 53.3498], // Dublin
            [4.4792, 51.9225], // Rotterdam
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dublin-Holyhead Route",
        operator: "Stena Line / Irish Ferries",
        duration: "2-3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.2603, 53.3498], // Dublin
            [-4.6336, 53.3094], // Holyhead
          ],
        ],
      },
    },

    // Baltic Sea Routes
    {
      type: "Feature",
      properties: {
        name: "Lübeck-Paldiski Route",
        operator: "Transfennica",
        duration: "27 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.6869, 53.8656], // Lübeck
            [24.05, 59.45], // Paldiski
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Travemünde-Liepāja Route",
        operator: "Stena Line",
        duration: "27 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.8786, 53.9575], // Travemünde
            [21.0167, 56.5167], // Liepāja
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kiel-Klaipėda Route",
        operator: "DFDS",
        duration: "21 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.1348, 54.3213], // Kiel
            [21.1175, 55.7069], // Klaipėda
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Tallinn-Helsinki Route",
        operator: "Tallink / Viking Line",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.7536, 59.437], // Tallinn
            [24.9384, 60.1699], // Helsinki
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Umeå-Vaasa Route",
        operator: "Wasaline",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [20.263, 63.8258], // Umeå
            [21.6164, 63.095], // Vaasa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kapellskär-Naantali Route",
        operator: "Finnlines",
        duration: "9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [19.0772, 59.3639], // Kapellskär
            [22.0, 60.4667], // Naantali
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Stockholm-Turku Route",
        operator: "Tallink Silja / Viking Line",
        duration: "11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.0686, 59.3293], // Stockholm
            [22.2666, 60.4518], // Turku
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lübeck-Kemi Route",
        operator: "Finnlines",
        duration: "48 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.6869, 53.8656], // Lübeck
            [24.5656, 65.7367], // Kemi
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lübeck-Oulu Route",
        operator: "Finnlines",
        duration: "45 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.6869, 53.8656], // Lübeck
            [25.4719, 65.0142], // Oulu
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lübeck-Rauma Route",
        operator: "Finnlines",
        duration: "38 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.6869, 53.8656], // Lübeck
            [21.5031, 61.1272], // Rauma
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lübeck-Kotka Route",
        operator: "Finnlines",
        duration: "42 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.6869, 53.8656], // Lübeck
            [26.95, 60.4667], // Kotka
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lübeck-Hanko Route",
        operator: "Finnlines",
        duration: "30 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.6869, 53.8656], // Lübeck
            [23.9597, 59.8231], // Hanko
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rostock-Hanko Route",
        operator: "Finnlines",
        duration: "24 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.0991, 54.0924], // Rostock
            [23.9597, 59.8231], // Hanko
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Travemünde-Helsinki Route",
        operator: "Finnlines",
        duration: "29 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.8786, 53.9575], // Travemünde
            [24.9384, 60.1699], // Helsinki
          ],
        ],
      },
    },

    // Norwegian Routes
    {
      type: "Feature",
      properties: {
        name: "Hirtshals-Bergen Route",
        operator: "Fjord Line",
        duration: "15 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [9.9633, 57.5936], // Hirtshals
            [5.3221, 60.3913], // Bergen
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Hirtshals-Stavanger Route",
        operator: "Fjord Line",
        duration: "10 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [9.9633, 57.5936], // Hirtshals
            [5.7331, 58.97], // Stavanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Hirtshals-Kristiansand Route",
        operator: "Color Line / Fjord Line",
        duration: "3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [9.9633, 57.5936], // Hirtshals
            [8.0059, 58.145], // Kristiansand
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Hirtshals-Larvik Route",
        operator: "Color Line",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [9.9633, 57.5936], // Hirtshals
            [9.75, 59.05], // Larvik
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kopenhagen-Oslo Route",
        operator: "DFDS",
        duration: "16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.5683, 55.6761], // Kopenhagen
            [10.7522, 59.9139], // Oslo
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Gdańsk-Nynäshamn Route",
        operator: "Polferries",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.6466, 54.352], // Gdańsk
            [17.0078, 58.5986], // Nynäshamn
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Sassnitz-Rønne Route",
        operator: "Bornholmslinjen",
        duration: "3.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.6114, 54.5089], // Sassnitz
            [14.7, 55.0333], // Rønne
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ystad-Rønne Route",
        operator: "Bornholmslinjen",
        duration: "1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.1569, 55.375], // Ystad
            [14.7, 55.0333], // Rønne
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oskarshamn-Visby Route",
        operator: "Destination Gotland",
        duration: "3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.5886, 56.1642], // Oskarshamn
            [18.3, 57.6333], // Visby
          ],
        ],
      },
    },
    // Baltic Sea Routes (continued)
    {
      type: "Feature",
      properties: {
        name: "Puttgarden-Rødby Route",
        operator: "Scandlines",
        duration: "45 Minuten",
        frequency: "Jede halbe Stunde",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.1581, 54.4789], // Puttgarden
            [11.3833, 54.6333], // Rødby
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Karlshamn-Klaipėda Route",
        operator: "DFDS",
        duration: "14 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.8086, 56.1628], // Karlshamn
            [21.1175, 55.7069], // Klaipėda
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Gdynia-Karlskrona Route",
        operator: "Stena Line",
        duration: "10 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.5305, 54.5189], // Gdynia
            [15.5869, 56.1621], // Karlskrona
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Świnoujście-Ystad Route",
        operator: "Unity Line",
        duration: "7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2444, 53.9175], // Świnoujście
            [13.1569, 55.375], // Ystad
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rostock-Trelleborg Route",
        operator: "Stena Line",
        duration: "6 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.0991, 54.0924], // Rostock
            [13.1608, 55.3761], // Trelleborg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Grenaa-Varberg Route",
        operator: "Stena Line",
        duration: "4 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.9167, 56.2667], // Grenaa
            [12.3333, 57.2667], // Varberg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Frederikshavn-Göteborg Route",
        operator: "Stena Line",
        duration: "3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.5333, 57.4333], // Frederikshavn
            [11.9746, 57.7089], // Göteborg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Travemünde-Trelleborg Route",
        operator: "TT-Line",
        duration: "7 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.8786, 53.9575], // Travemünde
            [13.1608, 55.3761], // Trelleborg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Travemünde-Malmö Route",
        operator: "Finnlines",
        duration: "9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.8786, 53.9575], // Travemünde
            [13.0038, 55.605], // Malmö
          ],
        ],
      },
    },

    // Spanish Mediterranean Routes
    {
      type: "Feature",
      properties: {
        name: "Valencia-Palma Route",
        operator: "Baleària / Trasmediterránea",
        duration: "7-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.3763, 39.4699], // Valencia
            [2.6502, 39.5696], // Palma
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Valencia-Ibiza Route",
        operator: "Baleària / Trasmediterránea",
        duration: "5-6 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.3763, 39.4699], // Valencia
            [1.4206, 38.9067], // Ibiza
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Barcelona-Ibiza Route",
        operator: "Baleària / Trasmediterránea",
        duration: "8-9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.1734, 41.3851], // Barcelona
            [1.4206, 38.9067], // Ibiza
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Barcelona-Ciutadella Route",
        operator: "Baleària / Trasmediterránea",
        duration: "7-8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.1734, 41.3851], // Barcelona
            [4.0667, 40.0], // Ciutadella
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Barcelona-Alcúdia Route",
        operator: "Baleària",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.1734, 41.3851], // Barcelona
            [3.1333, 39.85], // Alcúdia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Barcelona-Palma Route",
        operator: "Baleària / Trasmediterránea",
        duration: "7-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.1734, 41.3851], // Barcelona
            [2.6502, 39.5696], // Palma
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Alcúdia-Marseille Route",
        operator: "Corsica Ferries",
        duration: "11 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.1333, 39.85], // Alcúdia
            [5.3698, 43.2965], // Marseille
          ],
        ],
      },
    },

    // Italian Routes (Mainland to Sicily)
    {
      type: "Feature",
      properties: {
        name: "Genua-Neapel Route",
        operator: "Tirrenia",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [14.2681, 40.8518], // Neapel
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Genua-Palermo Route",
        operator: "Grandi Navi Veloci",
        duration: "20 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [13.3615, 38.1157], // Palermo
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Neapel-Palermo Route",
        operator: "Tirrenia / Grandi Navi Veloci",
        duration: "10 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [13.3615, 38.1157], // Palermo
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Catania-Salerno Route",
        operator: "Grimaldi Lines",
        duration: "9 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.083, 37.5079], // Catania
            [14.7681, 40.6824], // Salerno
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Genua-Catania Route",
        operator: "Grandi Navi Veloci",
        duration: "24 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [15.083, 37.5079], // Catania
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Pozzallo-Valletta Route",
        operator: "Virtu Ferries",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.7333, 36.9167], // Pozzallo
            [14.5146, 35.8989], // Valletta
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Livorno-Valletta Route",
        operator: "Grimaldi Lines",
        duration: "18 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.3047, 43.5511], // Livorno
            [14.5146, 35.8989], // Valletta
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Catania-Valletta Route",
        operator: "Virtu Ferries",
        duration: "4 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.083, 37.5079], // Catania
            [14.5146, 35.8989], // Valletta
          ],
        ],
      },
    },

    // Black Sea Routes
    {
      type: "Feature",
      properties: {
        name: "Poti-Chornomorsk Route",
        operator: "UKR Ferry",
        duration: "36 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [41.6667, 42.1667], // Poti
            [30.7233, 46.4825], // Chornomorsk
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Chornomorsk-Karasu Route",
        operator: "UKR Ferry",
        duration: "48 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [30.7233, 46.4825], // Chornomorsk
            [41.2, 41.0333], // Karasu
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Batumi-Chornomorsk Route",
        operator: "Georgia Ferry",
        duration: "40 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [41.6333, 42.15], // Batumi
            [30.7233, 46.4825], // Chornomorsk
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Burgas-Batumi Route",
        operator: "Navigation Maritime Bulgare",
        duration: "48 Stunden",
        frequency: "Mehrmals monatlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [27.4626, 42.5047], // Burgas
            [41.6333, 42.15], // Batumi
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Poti-Varna Route",
        operator: "Navigation Maritime Bulgare",
        duration: "42 Stunden",
        frequency: "Mehrmals monatlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [41.6667, 42.1667], // Poti
            [27.9161, 43.2047], // Varna
          ],
        ],
      },
    },

    // Mediterranean to Turkey/Eastern Med
    {
      type: "Feature",
      properties: {
        name: "Mersin-Triest Route",
        operator: "UND Ro-Ro",
        duration: "72 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [34.6333, 36.8], // Mersin
            [13.77, 45.65], // Triest
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Triest-Istanbul Route",
        operator: "DFDS / Ege Deniz",
        duration: "48 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.77, 45.65], // Triest
            [28.9784, 41.0082], // Istanbul
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Toulon-Pendik Route",
        operator: "UND Ro-Ro",
        duration: "72 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.928, 43.1242], // Toulon
            [29.2167, 40.8667], // Pendik
          ],
        ],
      },
    },

    // Greek Island Routes
    {
      type: "Feature",
      properties: {
        name: "Piräus-Rhodos Route",
        operator: "Blue Star Ferries / Anek Lines",
        duration: "12-16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [28.225, 36.4341], // Rhodos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Chania Route",
        operator: "Anek Lines / Minoan Lines",
        duration: "9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [24.018, 35.5138], // Chania
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Iraklio Route",
        operator: "Minoan Lines / Anek Lines",
        duration: "9 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.1442, 35.3387], // Iraklio
          ],
        ],
      },
    },

    // Italy to Greece/Albania
    {
      type: "Feature",
      properties: {
        name: "Ancona-Durrës Route",
        operator: "Adria Ferries",
        duration: "16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.5063, 43.7228], // Ancona
            [19.4569, 41.3231], // Durrës
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bari-Durrës Route",
        operator: "European Ferries / Adria Ferries",
        duration: "8-9 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.8719, 41.1171], // Bari
            [19.4569, 41.3231], // Durrës
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Venedig-Korfu Route",
        operator: "Anek Superfast / Minoan Lines",
        duration: "23 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.3155, 45.4408], // Venedig
            [19.9217, 39.6242], // Korfu
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Brindisi-Korfu Route",
        operator: "Grimaldi Lines / European Seaways",
        duration: "7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.947, 40.6384], // Brindisi
            [19.9217, 39.6242], // Korfu
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Venedig-Igoumenitsa Route",
        operator: "Anek Superfast / Minoan Lines",
        duration: "24 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.3155, 45.4408], // Venedig
            [20.8537, 39.665], // Igoumenitsa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ancona-Igoumenitsa Route",
        operator: "Anek Superfast / Minoan Lines",
        duration: "16-20 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.5063, 43.7228], // Ancona
            [20.8537, 39.665], // Igoumenitsa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Brindisi-Patras Route",
        operator: "Grimaldi Lines",
        duration: "14 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.947, 40.6384], // Brindisi
            [21.7346, 38.2466], // Patras
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bari-Patras Route",
        operator: "Anek Superfast",
        duration: "16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.8719, 41.1171], // Bari
            [21.7346, 38.2466], // Patras
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Venedig-Patras Route",
        operator: "Anek Superfast / Minoan Lines",
        duration: "30 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.3155, 45.4408], // Venedig
            [21.7346, 38.2466], // Patras
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Brindisi-Igoumenitsa Route",
        operator: "Grimaldi Lines / European Seaways",
        duration: "8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.947, 40.6384], // Brindisi
            [20.8537, 39.665], // Igoumenitsa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ancona-Patras Route",
        operator: "Anek Superfast / Minoan Lines",
        duration: "21 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.5063, 43.7228], // Ancona
            [21.7346, 38.2466], // Patras
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Patras-Savona Route",
        operator: "Grimaldi Lines",
        duration: "30 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.7346, 38.2466], // Patras
            [8.4689, 44.3106], // Savona
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Patras-Livorno Route",
        operator: "Grimaldi Lines",
        duration: "24 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.7346, 38.2466], // Patras
            [10.3047, 43.5511], // Livorno
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Patras-Genua Route",
        operator: "Grimaldi Lines",
        duration: "28 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.7346, 38.2466], // Patras
            [8.9463, 44.4056], // Genua
          ],
        ],
      },
    },
    // Sicily Strait Routes
    {
      type: "Feature",
      properties: {
        name: "Villa San Giovanni-Messina Route",
        operator: "Caronte & Tourist / Bluferries",
        duration: "20 Minuten",
        frequency: "Alle 20 Minuten",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.6422, 38.1897], // Villa San Giovanni
            [15.554, 38.1938], // Messina
          ],
        ],
      },
    },

    // Adriatic Routes
    {
      type: "Feature",
      properties: {
        name: "Bari-Split Route",
        operator: "Jadrolinija / SNAV",
        duration: "10 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.8719, 41.1171], // Bari
            [16.4402, 43.5081], // Split
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ancona-Split Route",
        operator: "SNAV / Jadrolinija",
        duration: "10-11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.5063, 43.7228], // Ancona
            [16.4402, 43.5081], // Split
          ],
        ],
      },
    },

    // Italian Island Routes (Sardinia)
    {
      type: "Feature",
      properties: {
        name: "Genua-Porto Torres Route",
        operator: "Tirrenia / Moby",
        duration: "12 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [8.4167, 40.8333], // Porto Torres
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Civitavecchia-Arbatax Route",
        operator: "Tirrenia",
        duration: "10 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.725, 42.0117], // Civitavecchia
            [9.6833, 39.9333], // Arbatax
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Palermo-Salerno Route",
        operator: "Grimaldi Lines",
        duration: "9 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.3615, 38.1157], // Palermo
            [14.7681, 40.6824], // Salerno
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Civitavecchia-Cagliari Route",
        operator: "Tirrenia / Grimaldi",
        duration: "14 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.725, 42.0117], // Civitavecchia
            [9.1167, 39.2167], // Cagliari
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Porto Torres-Barcelona Route",
        operator: "Grimaldi Lines",
        duration: "12 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.4167, 40.8333], // Porto Torres
            [2.1734, 41.3851], // Barcelona
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Civitavecchia-Porto Torres Route",
        operator: "Grimaldi Lines / Tirrenia",
        duration: "8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.725, 42.0117], // Civitavecchia
            [8.4167, 40.8333], // Porto Torres
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Livorno-Olbia Route",
        operator: "Moby / Grimaldi",
        duration: "6-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.3047, 43.5511], // Livorno
            [9.5, 40.9167], // Olbia
          ],
        ],
      },
    },

    // Corsica Routes
    {
      type: "Feature",
      properties: {
        name: "Savona-Bastia Route",
        operator: "Corsica Ferries",
        duration: "6 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.4689, 44.3106], // Savona
            [9.4508, 42.7019], // Bastia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Livorno-Bastia Route",
        operator: "Corsica Ferries / Moby",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.3047, 43.5511], // Livorno
            [9.4508, 42.7019], // Bastia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Toulon-Ile Rousse Route",
        operator: "Corsica Ferries",
        duration: "7 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.928, 43.1242], // Toulon
            [8.9333, 42.6333], // Ile Rousse
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Toulon-Bastia Route",
        operator: "Corsica Linea",
        duration: "8 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.928, 43.1242], // Toulon
            [9.4508, 42.7019], // Bastia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Toulon-Ajaccio Route",
        operator: "Corsica Linea",
        duration: "9 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.928, 43.1242], // Toulon
            [8.7386, 41.927], // Ajaccio
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Toulon-Porto Vecchio Route",
        operator: "Corsica Ferries",
        duration: "10 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.928, 43.1242], // Toulon
            [9.2806, 41.5908], // Porto Vecchio
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nizza-Ile Rousse Route",
        operator: "Corsica Ferries",
        duration: "5-6 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.2758, 43.6951], // Nizza
            [8.9333, 42.6333], // Ile Rousse
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nizza-Bastia Route",
        operator: "Corsica Ferries",
        duration: "5-6 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.2758, 43.6951], // Nizza
            [9.4508, 42.7019], // Bastia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nizza-Ajaccio Route",
        operator: "Corsica Ferries",
        duration: "6-7 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.2758, 43.6951], // Nizza
            [8.7386, 41.927], // Ajaccio
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nizza-Porto Vecchio Route",
        operator: "Corsica Ferries",
        duration: "7 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.2758, 43.6951], // Nizza
            [9.2806, 41.5908], // Porto Vecchio
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Livorno-Ile Rousse Route",
        operator: "Corsica Ferries",
        duration: "4 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.3047, 43.5511], // Livorno
            [8.9333, 42.6333], // Ile Rousse
          ],
        ],
      },
    },

    // Eastern Mediterranean Routes
    {
      type: "Feature",
      properties: {
        name: "Lavrio-Haifa Route",
        operator: "Grimaldi Lines",
        duration: "72 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.9667, 37.9667], // Lavrio
            [34.9892, 32.8156], // Haifa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lavrio-Limassol Route",
        operator: "Salamis Lines",
        duration: "40 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.9667, 37.9667], // Lavrio
            [33.0437, 34.6721], // Limassol
          ],
        ],
      },
    },

    // Canary Islands Routes
    {
      type: "Feature",
      properties: {
        name: "Cádiz-Las Palmas Route",
        operator: "Trasmediterránea",
        duration: "40 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3, 36.5333], // Cádiz
            [-15.4167, 28.1], // Las Palmas
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Cádiz-Arrecife Route",
        operator: "Trasmediterránea",
        duration: "32 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3, 36.5333], // Cádiz
            [-13.55, 28.9667], // Arrecife
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Cádiz-Santa Cruz Route",
        operator: "Trasmediterránea",
        duration: "42 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3, 36.5333], // Cádiz
            [-16.2546, 28.4682], // Santa Cruz de Tenerife
          ],
        ],
      },
    },

    // North Africa Routes
    {
      type: "Feature",
      properties: {
        name: "Algeciras-Tanger Route",
        operator: "FRS / Inter Shipping / Baleària",
        duration: "1 Stunde",
        frequency: "Stündlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.453, 36.1408], // Algeciras
            [-5.8337, 35.7595], // Tanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Genua-Tanger Route",
        operator: "Grandi Navi Veloci",
        duration: "48 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [-5.8337, 35.7595], // Tanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Sète-Tanger Route",
        operator: "Grandi Navi Veloci",
        duration: "36 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.6964, 43.4014], // Sète
            [-5.8337, 35.7595], // Tanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Sète-Nador Route",
        operator: "Grandi Navi Veloci",
        duration: "34 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.6964, 43.4014], // Sète
            [-2.9333, 35.1681], // Nador
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Palermo-Tunis Route",
        operator: "Grandi Navi Veloci",
        duration: "10 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.3615, 38.1157], // Palermo
            [10.1815, 36.8065], // Tunis
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Civitavecchia-Tunis Route",
        operator: "Grandi Navi Veloci",
        duration: "24 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.725, 42.0117], // Civitavecchia
            [10.1815, 36.8065], // Tunis
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Málaga-Melilla Route",
        operator: "Baleària / Trasmediterránea",
        duration: "7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-4.4167, 36.7167], // Málaga
            [-2.938, 35.2919], // Melilla
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Motril-Melilla Route",
        operator: "Baleària",
        duration: "7 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.5333, 36.7167], // Motril
            [-2.938, 35.2919], // Melilla
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Tarifa-Tanger Route",
        operator: "FRS",
        duration: "35 Minuten",
        frequency: "Stündlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.6058, 36.0128], // Tarifa
            [-5.8337, 35.7595], // Tanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Genua-Tunis Route",
        operator: "Grandi Navi Veloci / CTN",
        duration: "24 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [10.1815, 36.8065], // Tunis
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Almería-Melilla Route",
        operator: "Baleària / Trasmediterránea",
        duration: "6-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.4597, 36.8381], // Almería
            [-2.938, 35.2919], // Melilla
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Algeciras-Ceuta Route",
        operator: "FRS / Baleària / Trasmediterránea",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.453, 36.1408], // Algeciras
            [-5.3213, 35.8894], // Ceuta
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Barcelona-Tanger Route",
        operator: "Grandi Navi Veloci",
        duration: "30 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.1734, 41.3851], // Barcelona
            [-5.8337, 35.7595], // Tanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ghazaouet-Almería Route",
        operator: "Algérie Ferries",
        duration: "7 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.45, 35.1], // Ghazaouet
            [-2.4597, 36.8381], // Almería
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oran-Valencia Route",
        operator: "Algérie Ferries / Baleària",
        duration: "8 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.6331, 35.6969], // Oran
            [-0.3763, 39.4699], // Valencia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Mostaganem-Valencia Route",
        operator: "Algérie Ferries",
        duration: "9 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [0.09, 35.9317], // Mostaganem
            [-0.3763, 39.4699], // Valencia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nador-Almería Route",
        operator: "Baleària / Trasmediterránea",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9333, 35.1681], // Nador
            [-2.4597, 36.8381], // Almería
          ],
        ],
      },
    },

    // Additional Baltic Routes
    {
      type: "Feature",
      properties: {
        name: "Ventspils-Nynäshamn Route",
        operator: "Stena Line",
        duration: "9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.5619, 57.3956], // Ventspils
            [17.0078, 58.5986], // Nynäshamn
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ventspils-Travemünde Route",
        operator: "Stena Line",
        duration: "27 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.5619, 57.3956], // Ventspils
            [10.8786, 53.9575], // Travemünde
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Stockholm-Mariehamn-Turku Route",
        operator: "Viking Line / Tallink Silja",
        duration: "11 Stunden (via Mariehamn)",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.0686, 59.3293], // Stockholm
            [19.9333, 60.1], // Mariehamn
            [22.2666, 60.4518], // Turku
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Świnoujście-Rønne Route",
        operator: "Polferries",
        duration: "5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2444, 53.9175], // Świnoujście
            [14.7, 55.0333], // Rønne
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Stockholm-Riga Route",
        operator: "Tallink",
        duration: "16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.0686, 59.3293], // Stockholm
            [24.1052, 56.9496], // Riga
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nynäshamn-Hanko Route",
        operator: "Finnlines",
        duration: "10 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.0078, 58.5986], // Nynäshamn
            [23.9597, 59.8231], // Hanko
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Køge-Rønne Route",
        operator: "Bornholmslinjen",
        duration: "5.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.0833, 55.4833], // Køge
            [14.7, 55.0333], // Rønne
          ],
        ],
      },
    },

    // Additional Irish/UK Routes
    {
      type: "Feature",
      properties: {
        name: "Bilbao-Rosslare Route",
        operator: "Brittany Ferries",
        duration: "28 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9253, 43.2627], // Bilbao
            [-6.3397, 52.2486], // Rosslare
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nynäshamn-Visby Route",
        operator: "Destination Gotland",
        duration: "3 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.0078, 58.5986], // Nynäshamn
            [18.3, 57.6333], // Visby
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rosslare-Le Havre Route",
        operator: "Stena Line",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3397, 52.2486], // Rosslare
            [0.1079, 49.4938], // Le Havre
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dünkirchen-Rosslare Route",
        operator: "DFDS",
        duration: "24 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.3773, 51.0347], // Dünkirchen
            [-6.3397, 52.2486], // Rosslare
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Hirtshals-Seyðisfjörður Route",
        operator: "Smyril Line",
        duration: "47 Stunden",
        frequency: "Wöchentlich (Sommer)",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [9.9633, 57.5936], // Hirtshals
            [-14.0145, 65.2627], // Seyðisfjörður
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Świnoujście-Trelleborg Route",
        operator: "TT-Line / Unity Line",
        duration: "6 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2444, 53.9175], // Świnoujście
            [13.1608, 55.3761], // Trelleborg
          ],
        ],
      },
    },

    // Füge diese 50 weiteren Routen zum ferryRoutesGeoJSON.features Array hinzu:

    // French Atlantic Routes
    {
      type: "Feature",
      properties: {
        name: "Roscoff-Plymouth Route",
        operator: "Brittany Ferries",
        duration: "6 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.4667, 48.75], // Roscoff
            [-4.1427, 50.3755], // Plymouth
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Marseille-Bastia Route",
        operator: "Corsica Linea",
        duration: "11 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3698, 43.2965], // Marseille
            [9.4508, 42.7019], // Bastia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Marseille-Ajaccio Route",
        operator: "Corsica Linea / La Méridionale",
        duration: "12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3698, 43.2965], // Marseille
            [8.7386, 41.927], // Ajaccio
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Marseille-Porto Vecchio Route",
        operator: "Corsica Linea",
        duration: "13 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3698, 43.2965], // Marseille
            [9.2806, 41.5908], // Porto Vecchio
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Marseille-Ile Rousse Route",
        operator: "Corsica Linea",
        duration: "11 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3698, 43.2965], // Marseille
            [8.9333, 42.6333], // Ile Rousse
          ],
        ],
      },
    },

    // Italian Sardinia Routes (continued)
    {
      type: "Feature",
      properties: {
        name: "Genua-Olbia Route",
        operator: "Moby / Grandi Navi Veloci",
        duration: "10-12 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [9.5, 40.9167], // Olbia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Civitavecchia-Olbia Route",
        operator: "Moby / Grimaldi",
        duration: "6-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.725, 42.0117], // Civitavecchia
            [9.5, 40.9167], // Olbia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Savona-Porto Torres Route",
        operator: "Grimaldi Lines",
        duration: "12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.4689, 44.3106], // Savona
            [8.4167, 40.8333], // Porto Torres
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piombino-Olbia Route",
        operator: "Moby",
        duration: "6 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.5244, 42.9233], // Piombino
            [9.5, 40.9167], // Olbia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Genua-Cagliari Route",
        operator: "Tirrenia",
        duration: "14 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.9463, 44.4056], // Genua
            [9.1167, 39.2167], // Cagliari
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Neapel-Cagliari Route",
        operator: "Tirrenia",
        duration: "15 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [9.1167, 39.2167], // Cagliari
          ],
        ],
      },
    },

    // More Greek Island Routes
    {
      type: "Feature",
      properties: {
        name: "Piräus-Santorin Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "5-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.4317, 36.3932], // Santorin
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Mykonos Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "3-5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.3289, 37.4467], // Mykonos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Naxos Route",
        operator: "Blue Star Ferries",
        duration: "4-6 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.3769, 37.1036], // Naxos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Paros Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "4-5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.1489, 37.0853], // Paros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Kos Route",
        operator: "Blue Star Ferries",
        duration: "10-12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [27.2908, 36.8933], // Kos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Lesbos Route",
        operator: "Blue Star Ferries",
        duration: "10-12 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [26.5553, 39.1069], // Lesbos (Mytilini)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Samos Route",
        operator: "Blue Star Ferries",
        duration: "11-13 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [26.9722, 37.7564], // Samos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rafina-Mykonos Route",
        operator: "SeaJets / Golden Star Ferries",
        duration: "2-4 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.0119, 38.0236], // Rafina
            [25.3289, 37.4467], // Mykonos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rafina-Santorin Route",
        operator: "SeaJets / Golden Star Ferries",
        duration: "4-6 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.0119, 38.0236], // Rafina
            [25.4317, 36.3932], // Santorin
          ],
        ],
      },
    },

    // More Norwegian Routes
    {
      type: "Feature",
      properties: {
        name: "Hirtshals-Langesund Route",
        operator: "Fjord Line",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [9.9633, 57.5936], // Hirtshals
            [9.6667, 59.1333], // Langesund
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Strömstad-Sandefjord Route",
        operator: "Color Line",
        duration: "2.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.1753, 58.9378], // Strömstad
            [10.2167, 59.1333], // Sandefjord
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Frederikshavn-Larvik Route",
        operator: "Color Line",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.5333, 57.4333], // Frederikshavn
            [9.75, 59.05], // Larvik
          ],
        ],
      },
    },

    // More Baltic Routes
    {
      type: "Feature",
      properties: {
        name: "Rostock-Gedser Route",
        operator: "Scandlines",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.0991, 54.0924], // Rostock
            [11.9267, 54.5744], // Gedser
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Helsingør-Helsingborg Route",
        operator: "Scandlines / Forsea",
        duration: "20 Minuten",
        frequency: "Alle 15 Minuten",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.6136, 56.0364], // Helsingør
            [12.6945, 56.0465], // Helsingborg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kapellskär-Paldiski Route",
        operator: "DFDS",
        duration: "9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [19.0772, 59.3639], // Kapellskär
            [24.05, 59.45], // Paldiski
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Stockholm-Tallinn Route",
        operator: "Tallink",
        duration: "15 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.0686, 59.3293], // Stockholm
            [24.7536, 59.437], // Tallinn
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Helsinki-Stockholm Route",
        operator: "Tallink Silja / Viking Line",
        duration: "16 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.9384, 60.1699], // Helsinki
            [18.0686, 59.3293], // Stockholm
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Turku-Stockholm Route",
        operator: "Tallink Silja",
        duration: "11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [22.2666, 60.4518], // Turku
            [18.0686, 59.3293], // Stockholm
          ],
        ],
      },
    },

    // Additional Spanish Routes
    {
      type: "Feature",
      properties: {
        name: "Dénia-Ibiza Route",
        operator: "Baleària",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.1065, 38.8408], // Dénia
            [1.4206, 38.9067], // Ibiza
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dénia-Palma Route",
        operator: "Baleària",
        duration: "4-5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.1065, 38.8408], // Dénia
            [2.6502, 39.5696], // Palma
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Palma-Ibiza Route",
        operator: "Baleària / Trasmediterránea",
        duration: "2-3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.6502, 39.5696], // Palma
            [1.4206, 38.9067], // Ibiza
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ibiza-Formentera Route",
        operator: "Baleària / Trasmapi",
        duration: "30 Minuten",
        frequency: "Stündlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.4206, 38.9067], // Ibiza
            [1.4322, 38.7117], // Formentera
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Palma-Ciutadella Route",
        operator: "Baleària / Trasmediterránea",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.6502, 39.5696], // Palma
            [4.0667, 40.0], // Ciutadella
          ],
        ],
      },
    },

    // Additional UK Channel Routes
    {
      type: "Feature",
      properties: {
        name: "Portsmouth-Le Havre Route",
        operator: "Brittany Ferries",
        duration: "5-8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.0872, 50.8058], // Portsmouth
            [0.1079, 49.4938], // Le Havre
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Portsmouth-Caen Route",
        operator: "Brittany Ferries",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.0872, 50.8058], // Portsmouth
            [-0.3667, 49.1833], // Caen (Ouistreham)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Portsmouth-St Malo Route",
        operator: "Brittany Ferries",
        duration: "8-11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.0872, 50.8058], // Portsmouth
            [-2.0256, 48.6492], // St Malo
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Poole-St Malo Route",
        operator: "Brittany Ferries",
        duration: "6 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.9872, 50.7155], // Poole
            [-2.0256, 48.6492], // St Malo
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Plymouth-Roscoff Route",
        operator: "Brittany Ferries",
        duration: "6 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-4.1427, 50.3755], // Plymouth
            [-3.4667, 48.75], // Roscoff
          ],
        ],
      },
    },

    // More Italian Routes
    {
      type: "Feature",
      properties: {
        name: "Neapel-Capri Route",
        operator: "Caremar / SNAV",
        duration: "50 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [14.2428, 40.5508], // Capri
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Neapel-Ischia Route",
        operator: "Caremar / Medmar",
        duration: "1-1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [13.9536, 40.7322], // Ischia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Neapel-Procida Route",
        operator: "Caremar / SNAV",
        duration: "40 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [14.0197, 40.7583], // Procida
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Trapani-Pantelleria Route",
        operator: "Liberty Lines / Siremar",
        duration: "2.5-6 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.5367, 38.0181], // Trapani
            [11.9611, 36.8167], // Pantelleria
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Porto Empedocle-Lampedusa Route",
        operator: "Siremar",
        duration: "8 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.5267, 37.2906], // Porto Empedocle
            [12.6086, 35.5086], // Lampedusa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Lipari Route",
        operator: "Liberty Lines / Siremar",
        duration: "1-2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [14.9536, 38.4669], // Lipari
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Vulcano Route",
        operator: "Liberty Lines / Siremar",
        duration: "1-1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [14.9617, 38.4042], // Vulcano
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Palermo-Ustica Route",
        operator: "Liberty Lines",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.3615, 38.1157], // Palermo
            [13.1867, 38.7086], // Ustica
          ],
        ],
      },
    },

    // Additional Croatian Routes
    {
      type: "Feature",
      properties: {
        name: "Split-Hvar Route",
        operator: "Jadrolinija",
        duration: "1-2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.4422, 43.1728], // Hvar
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Split-Brač Route",
        operator: "Jadrolinija",
        duration: "50 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.6367, 43.3167], // Brač (Supetar)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Split-Vis Route",
        operator: "Jadrolinija",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.1833, 43.0619], // Vis
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dubrovnik-Korčula Route",
        operator: "Jadrolinija / Krilo",
        duration: "2-3 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.1094, 42.6507], // Dubrovnik
            [17.1342, 42.9597], // Korčula
          ],
        ],
      },
    },

    // Füge diese 50 weiteren Routen zum ferryRoutesGeoJSON.features Array hinzu:

    // Additional Spanish Mediterranean & Balearic Routes
    {
      type: "Feature",
      properties: {
        name: "Dénia-Formentera Route",
        operator: "Baleària",
        duration: "2.5 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.1065, 38.8408], // Dénia
            [1.4322, 38.7117], // Formentera
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Valencia-Ciutadella Route",
        operator: "Trasmediterránea",
        duration: "8 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.3763, 39.4699], // Valencia
            [4.0667, 40.0], // Ciutadella
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Valencia-Alcúdia Route",
        operator: "Baleària",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.3763, 39.4699], // Valencia
            [3.1333, 39.85], // Alcúdia
          ],
        ],
      },
    },

    // Additional French Mediterranean Routes
    {
      type: "Feature",
      properties: {
        name: "Marseille-Algiers Route",
        operator: "Algérie Ferries",
        duration: "22 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3698, 43.2965], // Marseille
            [3.0588, 36.7538], // Algiers
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Sète-Algiers Route",
        operator: "Algérie Ferries",
        duration: "20 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.6964, 43.4014], // Sète
            [3.0588, 36.7538], // Algiers
          ],
        ],
      },
    },

    // More Italian Mainland Routes
    {
      type: "Feature",
      properties: {
        name: "Livorno-Piombino Route",
        operator: "Toremar",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.3047, 43.5511], // Livorno
            [10.5244, 42.9233], // Piombino
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piombino-Elba Route",
        operator: "Toremar / Moby",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.5244, 42.9233], // Piombino
            [10.3167, 42.8167], // Portoferraio (Elba)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Livorno-Capraia Route",
        operator: "Toremar",
        duration: "2.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.3047, 43.5511], // Livorno
            [9.8333, 43.05], // Capraia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piombino-Pianosa Route",
        operator: "Toremar",
        duration: "2 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.5244, 42.9233], // Piombino
            [10.0833, 42.5833], // Pianosa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Porto Santo Stefano-Giglio Route",
        operator: "Toremar / Maregiglio",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.1128, 42.4339], // Porto Santo Stefano
            [10.8833, 42.3667], // Giglio Porto
          ],
        ],
      },
    },

    // More Adriatic & Croatian Routes
    {
      type: "Feature",
      properties: {
        name: "Zadar-Ancona Route",
        operator: "Jadrolinija",
        duration: "7-9 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2422, 44.1194], // Zadar
            [13.5063, 43.7228], // Ancona
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dubrovnik-Bari Route",
        operator: "Jadrolinija",
        duration: "9-10 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.1094, 42.6507], // Dubrovnik
            [16.8719, 41.1171], // Bari
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Split-Ancona Route",
        operator: "SNAV / Jadrolinija",
        duration: "10-11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [13.5063, 43.7228], // Ancona
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rijeka-Dubrovnik Route",
        operator: "Jadrolinija",
        duration: "22 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.4419, 45.3269], // Rijeka
            [18.1094, 42.6507], // Dubrovnik
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Split-Supetar (Brač) Route",
        operator: "Jadrolinija",
        duration: "50 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.6367, 43.3167], // Supetar
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Split-Stari Grad (Hvar) Route",
        operator: "Jadrolinija",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.5944, 43.1842], // Stari Grad
          ],
        ],
      },
    },

    // More Greek Island Routes (Cyclades & Dodecanese)
    {
      type: "Feature",
      properties: {
        name: "Piräus-Ios Route",
        operator: "Blue Star Ferries",
        duration: "6-8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.2931, 36.7167], // Ios
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Milos Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "4-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [24.4258, 36.7342], // Milos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Syros Route",
        operator: "Blue Star Ferries",
        duration: "2.5-4 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [24.9406, 37.4447], // Syros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Tinos Route",
        operator: "Blue Star Ferries",
        duration: "3-5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [25.1619, 37.5378], // Tinos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Andros Route",
        operator: "Blue Star Ferries",
        duration: "2-4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [24.9386, 37.8333], // Andros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Kalymnos Route",
        operator: "Blue Star Ferries",
        duration: "9-12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [26.9872, 36.9511], // Kalymnos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Leros Route",
        operator: "Blue Star Ferries",
        duration: "8-11 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [26.8458, 37.1333], // Leros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rhodos-Kos Route",
        operator: "Blue Star Ferries",
        duration: "2-3 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [28.225, 36.4341], // Rhodos
            [27.2908, 36.8933], // Kos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kos-Bodrum Route",
        operator: "Bodrum Express / Bodrum Ferries",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich (Sommer)",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [27.2908, 36.8933], // Kos
            [27.4305, 37.0344], // Bodrum
          ],
        ],
      },
    },

    // More Greek Mainland to Islands
    {
      type: "Feature",
      properties: {
        name: "Rafina-Andros Route",
        operator: "Golden Star Ferries",
        duration: "2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.0119, 38.0236], // Rafina
            [24.9386, 37.8333], // Andros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rafina-Tinos Route",
        operator: "Golden Star Ferries",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.0119, 38.0236], // Rafina
            [25.1619, 37.5378], // Tinos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lavrio-Kea Route",
        operator: "SeaJets",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.9667, 37.9667], // Lavrio
            [24.3333, 37.6167], // Kea
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lavrio-Kythnos Route",
        operator: "SeaJets",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.9667, 37.9667], // Lavrio
            [24.4167, 37.4], // Kythnos
          ],
        ],
      },
    },

    // Additional Scandinavian Routes
    {
      type: "Feature",
      properties: {
        name: "Umeå-Vasa Route",
        operator: "Wasaline",
        duration: "4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [20.263, 63.8258], // Umeå
            [21.6164, 63.095], // Vaasa
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Nynäshamn-Visby Route",
        operator: "Destination Gotland",
        duration: "3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.0078, 58.5986], // Nynäshamn
            [18.3, 57.6333], // Visby
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Oskarshamn-Visby Route",
        operator: "Destination Gotland",
        duration: "3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.5886, 56.1642], // Oskarshamn
            [18.3, 57.6333], // Visby
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Västervik-Visby Route",
        operator: "Destination Gotland",
        duration: "2.5 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.6369, 57.7586], // Västervik
            [18.3, 57.6333], // Visby
          ],
        ],
      },
    },

    // More Baltic Routes
    {
      type: "Feature",
      properties: {
        name: "Karlskrona-Gdynia Route",
        operator: "Stena Line",
        duration: "10 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.5869, 56.1621], // Karlskrona
            [18.5305, 54.5189], // Gdynia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ystad-Świnoujście Route",
        operator: "Unity Line",
        duration: "7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.1569, 55.375], // Ystad
            [14.2444, 53.9175], // Świnoujście
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kapellskär-Mariehamn Route",
        operator: "Viking Line",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [19.0772, 59.3639], // Kapellskär
            [19.9333, 60.1], // Mariehamn
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Turku-Mariehamn Route",
        operator: "Viking Line / Tallink Silja",
        duration: "5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [22.2666, 60.4518], // Turku
            [19.9333, 60.1], // Mariehamn
          ],
        ],
      },
    },

    // North Sea Routes
    {
      type: "Feature",
      properties: {
        name: "Newcastle-Amsterdam Route",
        operator: "DFDS",
        duration: "15 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.6178, 54.9783], // Newcastle
            [4.8945, 52.3676], // Amsterdam
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Harwich-Europoort Route",
        operator: "Stena Line",
        duration: "6.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.2833, 51.9469], // Harwich
            [4.0167, 51.9333], // Europoort
          ],
        ],
      },
    },

    // Channel Islands Routes
    {
      type: "Feature",
      properties: {
        name: "Poole-Jersey Route",
        operator: "Condor Ferries",
        duration: "3-4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.9872, 50.7155], // Poole
            [-2.1167, 49.2144], // St Helier (Jersey)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Poole-Guernsey Route",
        operator: "Condor Ferries",
        duration: "3 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.9872, 50.7155], // Poole
            [-2.5372, 49.4533], // St Peter Port (Guernsey)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Portsmouth-Jersey Route",
        operator: "Condor Ferries",
        duration: "10-12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.0872, 50.8058], // Portsmouth
            [-2.1167, 49.2144], // St Helier (Jersey)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "St Malo-Jersey Route",
        operator: "Condor Ferries / Manche Îles Express",
        duration: "1.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.0256, 48.6492], // St Malo
            [-2.1167, 49.2144], // St Helier (Jersey)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "St Malo-Guernsey Route",
        operator: "Condor Ferries",
        duration: "2 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.0256, 48.6492], // St Malo
            [-2.5372, 49.4533], // St Peter Port (Guernsey)
          ],
        ],
      },
    },

    // Additional Turkish Routes
    {
      type: "Feature",
      properties: {
        name: "Çeşme-Chios Route",
        operator: "Various operators",
        duration: "30-45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [26.3069, 38.3222], // Çeşme
            [26.1369, 38.3678], // Chios
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kuşadası-Samos Route",
        operator: "Various operators",
        duration: "1-1.5 Stunden",
        frequency: "Mehrmals täglich (Sommer)",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [27.2611, 37.8597], // Kuşadası
            [26.9722, 37.7564], // Samos (Vathy)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Marmaris-Rhodos Route",
        operator: "Various operators",
        duration: "1-2 Stunden",
        frequency: "Mehrmals täglich (Sommer)",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [28.2742, 36.8531], // Marmaris
            [28.225, 36.4341], // Rhodos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Fethiye-Rhodos Route",
        operator: "Various operators",
        duration: "2-3 Stunden",
        frequency: "Mehrmals wöchentlich (Sommer)",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [29.1164, 36.6217], // Fethiye
            [28.225, 36.4341], // Rhodos
          ],
        ],
      },
    },

    // Additional North African Routes
    {
      type: "Feature",
      properties: {
        name: "Barcelona-Algiers Route",
        operator: "Algérie Ferries",
        duration: "24 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [2.1734, 41.3851], // Barcelona
            [3.0588, 36.7538], // Algiers
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Marseille-Oran Route",
        operator: "Algérie Ferries",
        duration: "20 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3698, 43.2965], // Marseille
            [-0.6331, 35.6969], // Oran
          ],
        ],
      },
    },

    // Aegean Islands Internal Routes
    {
      type: "Feature",
      properties: {
        name: "Mykonos-Santorin Route",
        operator: "SeaJets / Golden Star Ferries",
        duration: "2-3 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.3289, 37.4467], // Mykonos
            [25.4317, 36.3932], // Santorin
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Naxos-Santorin Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "2-3 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.3769, 37.1036], // Naxos
            [25.4317, 36.3932], // Santorin
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Paros-Santorin Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "2.5-4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.1489, 37.0853], // Paros
            [25.4317, 36.3932], // Santorin
          ],
        ],
      },
    },

    // Füge diese 50 weiteren Routen zum ferryRoutesGeoJSON.features Array hinzu:

    // Additional Danish Bridge/Ferry Crossings
    {
      type: "Feature",
      properties: {
        name: "Helsingør-Helsingborg Route",
        operator: "Scandlines / Forsea",
        duration: "20 Minuten",
        frequency: "Alle 15 Minuten",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.6136, 56.0364], // Helsingør
            [12.6945, 56.0465], // Helsingborg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Gedser-Rostock Route",
        operator: "Scandlines",
        duration: "1.5-2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.9267, 54.5744], // Gedser
            [12.0991, 54.0924], // Rostock
          ],
        ],
      },
    },

    // More Norwegian Fjord Routes
    {
      type: "Feature",
      properties: {
        name: "Bergen-Stavanger Route",
        operator: "Fjord Line",
        duration: "5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.3221, 60.3913], // Bergen
            [5.7331, 58.97], // Stavanger
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kristiansand-Langesund Route",
        operator: "Fjord Line",
        duration: "2.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.0059, 58.145], // Kristiansand
            [9.6667, 59.1333], // Langesund
          ],
        ],
      },
    },

    // Additional Swedish-German Routes
    {
      type: "Feature",
      properties: {
        name: "Trelleborg-Sassnitz Route",
        operator: "FRS",
        duration: "3.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.1608, 55.3761], // Trelleborg
            [13.6114, 54.5089], // Sassnitz
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Trelleborg-Rostock Route",
        operator: "Stena Line / TT-Line",
        duration: "5-6 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.1608, 55.3761], // Trelleborg
            [12.0991, 54.0924], // Rostock
          ],
        ],
      },
    },

    // More Italian Aeolian Islands
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Stromboli Route",
        operator: "Liberty Lines / Siremar",
        duration: "2-3 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [15.2139, 38.7889], // Stromboli
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Panarea Route",
        operator: "Liberty Lines / Siremar",
        duration: "2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [15.0639, 38.6306], // Panarea
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Salina Route",
        operator: "Liberty Lines / Siremar",
        duration: "1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [14.8444, 38.5667], // Salina
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Filicudi Route",
        operator: "Siremar",
        duration: "2-3 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [14.5667, 38.5667], // Filicudi
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Milazzo-Alicudi Route",
        operator: "Siremar",
        duration: "3-4 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2433, 38.2236], // Milazzo
            [14.3522, 38.5444], // Alicudi
          ],
        ],
      },
    },

    // More Italian Mainland-Sicily Routes
    {
      type: "Feature",
      properties: {
        name: "Reggio Calabria-Messina Route",
        operator: "Caronte & Tourist / Bluferries",
        duration: "20-30 Minuten",
        frequency: "Alle 20 Minuten",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.6472, 38.1103], // Reggio Calabria
            [15.554, 38.1938], // Messina
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Salerno-Messina Route",
        operator: "Caronte & Tourist",
        duration: "8-9 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.7681, 40.6824], // Salerno
            [15.554, 38.1938], // Messina
          ],
        ],
      },
    },

    // More Sardinia Connections
    {
      type: "Feature",
      properties: {
        name: "Palermo-Cagliari Route",
        operator: "Tirrenia",
        duration: "12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [13.3615, 38.1157], // Palermo
            [9.1167, 39.2167], // Cagliari
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Trapani-Cagliari Route",
        operator: "Grimaldi Lines",
        duration: "11 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.5367, 38.0181], // Trapani
            [9.1167, 39.2167], // Cagliari
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Naples-Olbia Route",
        operator: "Tirrenia",
        duration: "12 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [9.5, 40.9167], // Olbia
          ],
        ],
      },
    },

    // More Croatian Dalmatian Islands
    {
      type: "Feature",
      properties: {
        name: "Split-Bol (Brač) Route",
        operator: "Jadrolinija",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.6556, 43.2631], // Bol
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Split-Milna (Brač) Route",
        operator: "Jadrolinija",
        duration: "1 Stunde",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.4402, 43.5081], // Split
            [16.4472, 43.3275], // Milna
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zadar-Dugi Otok Route",
        operator: "Jadrolinija",
        duration: "2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2422, 44.1194], // Zadar
            [14.9167, 44.0], // Dugi Otok
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zadar-Ugljan Route",
        operator: "Jadrolinija",
        duration: "25 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2422, 44.1194], // Zadar
            [15.1167, 44.1167], // Ugljan
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zadar-Pag Route",
        operator: "Jadrolinija",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2422, 44.1194], // Zadar
            [15.0667, 44.4333], // Pag
          ],
        ],
      },
    },

    // More Greek Cyclades Routes
    {
      type: "Feature",
      properties: {
        name: "Paros-Naxos Route",
        operator: "Blue Star Ferries / SeaJets",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.1489, 37.0853], // Paros
            [25.3769, 37.1036], // Naxos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Naxos-Mykonos Route",
        operator: "SeaJets",
        duration: "2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.3769, 37.1036], // Naxos
            [25.3289, 37.4467], // Mykonos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Paros-Mykonos Route",
        operator: "SeaJets",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.1489, 37.0853], // Paros
            [25.3289, 37.4467], // Mykonos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ios-Santorin Route",
        operator: "SeaJets / Blue Star Ferries",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.2931, 36.7167], // Ios
            [25.4317, 36.3932], // Santorin
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Naxos-Ios Route",
        operator: "Blue Star Ferries",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.3769, 37.1036], // Naxos
            [25.2931, 36.7167], // Ios
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Paros-Ios Route",
        operator: "Blue Star Ferries",
        duration: "2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [25.1489, 37.0853], // Paros
            [25.2931, 36.7167], // Ios
          ],
        ],
      },
    },

    // More Greek Dodecanese Routes
    {
      type: "Feature",
      properties: {
        name: "Rhodos-Symi Route",
        operator: "Blue Star Ferries / Dodekanisos Seaways",
        duration: "1-2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [28.225, 36.4341], // Rhodos
            [27.8383, 36.6167], // Symi
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rhodos-Karpathos Route",
        operator: "Blue Star Ferries / Anek Lines",
        duration: "5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [28.225, 36.4341], // Rhodos
            [27.2133, 35.5131], // Karpathos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rhodos-Chalki Route",
        operator: "Dodekanisos Seaways",
        duration: "1.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [28.225, 36.4341], // Rhodos
            [27.6167, 36.2333], // Chalki
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kos-Kalymnos Route",
        operator: "Blue Star Ferries / Dodekanisos Seaways",
        duration: "1-2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [27.2908, 36.8933], // Kos
            [26.9872, 36.9511], // Kalymnos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kos-Leros Route",
        operator: "Blue Star Ferries",
        duration: "2 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [27.2908, 36.8933], // Kos
            [26.8458, 37.1333], // Leros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kalymnos-Leros Route",
        operator: "Blue Star Ferries / Dodekanisos Seaways",
        duration: "45 Minuten",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [26.9872, 36.9511], // Kalymnos
            [26.8458, 37.1333], // Leros
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Leros-Patmos Route",
        operator: "Blue Star Ferries / Dodekanisos Seaways",
        duration: "1 Stunde",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [26.8458, 37.1333], // Leros
            [26.5472, 37.3086], // Patmos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Piräus-Patmos Route",
        operator: "Blue Star Ferries",
        duration: "7-9 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.6458, 37.9471], // Piräus
            [26.5472, 37.3086], // Patmos
          ],
        ],
      },
    },

    // More Greek Sporades Routes
    {
      type: "Feature",
      properties: {
        name: "Volos-Skiathos Route",
        operator: "Hellenic Seaways",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [22.9444, 39.3611], // Volos
            [23.4906, 39.1633], // Skiathos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Volos-Skopelos Route",
        operator: "Hellenic Seaways",
        duration: "3-4 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [22.9444, 39.3611], // Volos
            [23.7167, 39.1167], // Skopelos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Volos-Alonissos Route",
        operator: "Hellenic Seaways",
        duration: "4-5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [22.9444, 39.3611], // Volos
            [23.8667, 39.15], // Alonissos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Skiathos-Skopelos Route",
        operator: "Hellenic Seaways",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.4906, 39.1633], // Skiathos
            [23.7167, 39.1167], // Skopelos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Skopelos-Alonissos Route",
        operator: "Hellenic Seaways",
        duration: "1 Stunde",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [23.7167, 39.1167], // Skopelos
            [23.8667, 39.15], // Alonissos
          ],
        ],
      },
    },

    // More Spanish Balearic Internal Routes
    {
      type: "Feature",
      properties: {
        name: "Ibiza-Ciutadella Route",
        operator: "Baleària",
        duration: "2 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.4206, 38.9067], // Ibiza
            [4.0667, 40.0], // Ciutadella
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Alcúdia-Ciutadella Route",
        operator: "Baleària",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [3.1333, 39.85], // Alcúdia
            [4.0667, 40.0], // Ciutadella
          ],
        ],
      },
    },

    // More French-British Channel Routes
    {
      type: "Feature",
      properties: {
        name: "Caen-Portsmouth Route",
        operator: "Brittany Ferries",
        duration: "5.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.3667, 49.1833], // Caen (Ouistreham)
            [-1.0872, 50.8058], // Portsmouth
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "St Malo-Poole Route",
        operator: "Brittany Ferries",
        duration: "6-7 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.0256, 48.6492], // St Malo
            [-1.9872, 50.7155], // Poole
          ],
        ],
      },
    },

    // More Mediterranean-Africa Routes
    {
      type: "Feature",
      properties: {
        name: "Almería-Nador Route",
        operator: "Naviera Armas / Trasmediterránea",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.4597, 36.8381], // Almería
            [-2.9333, 35.1681], // Nador
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Almería-Ghazaouet Route",
        operator: "Algérie Ferries",
        duration: "7-8 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.4597, 36.8381], // Almería
            [-1.45, 35.1], // Ghazaouet
          ],
        ],
      },
    },

    // Additional Baltic Crossings
    {
      type: "Feature",
      properties: {
        name: "Gdynia-Nynäshamn Route",
        operator: "Polferries",
        duration: "18 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.5305, 54.5189], // Gdynia
            [17.0078, 58.5986], // Nynäshamn
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Karlskrona-Gdynia Route",
        operator: "Stena Line",
        duration: "10-11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.5869, 56.1621], // Karlskrona
            [18.5305, 54.5189], // Gdynia
          ],
        ],
      },
    },

    // Additional Finnish-Åland Routes
    {
      type: "Feature",
      properties: {
        name: "Helsinki-Mariehamn Route",
        operator: "Viking Line / Tallink Silja",
        duration: "6-7 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.9384, 60.1699], // Helsinki
            [19.9333, 60.1], // Mariehamn
          ],
        ],
      },
    },

    // More UK-Ireland Routes
    {
      type: "Feature",
      properties: {
        name: "Liverpool-Dublin Route",
        operator: "P&O Ferries / Irish Ferries",
        duration: "7-8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9916, 53.4084], // Liverpool
            [-6.2603, 53.3498], // Dublin
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Liverpool-Belfast Route",
        operator: "Stena Line",
        duration: "8 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9916, 53.4084], // Liverpool
            [-5.93, 54.5964], // Belfast
          ],
        ],
      },
    },

    // Füge diese 50 weiteren Routen zum ferryRoutesGeoJSON.features Array hinzu:

    // Additional Scottish Western Isles Routes
    {
      type: "Feature",
      properties: {
        name: "Mallaig-Armadale Route",
        operator: "CalMac Ferries",
        duration: "30 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.8278, 56.9833], // Mallaig
            [-5.8986, 57.0731], // Armadale (Skye)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Glenelg-Kylerhea Route",
        operator: "Glenelg Ferry",
        duration: "5 Minuten",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-5.6167, 57.2333], // Glenelg
            [-5.6833, 57.2667], // Kylerhea (Skye)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Tobermory-Kilchoan Route",
        operator: "CalMac Ferries",
        duration: "35 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.0625, 56.6231], // Tobermory
            [-6.1, 56.7], // Kilchoan
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Fionnphort-Iona Route",
        operator: "CalMac Ferries",
        duration: "10 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.3711, 56.3164], // Fionnphort
            [-6.4111, 56.3333], // Iona
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Leverburgh-Berneray Route",
        operator: "CalMac Ferries",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.9833, 57.7667], // Leverburgh
            [-7.1833, 57.7167], // Berneray
          ],
        ],
      },
    },

    // Additional Northern Scottish Routes
    {
      type: "Feature",
      properties: {
        name: "Kirkwall-Westray Route",
        operator: "Orkney Ferries",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9597, 58.9811], // Kirkwall
            [-2.95, 59.35], // Westray
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kirkwall-Sanday Route",
        operator: "Orkney Ferries",
        duration: "1.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.9597, 58.9811], // Kirkwall
            [-2.5833, 59.25], // Sanday
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Gills Bay-St Margaret's Hope Route",
        operator: "Pentland Ferries",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.0667, 58.6333], // Gills Bay
            [-2.9833, 58.8333], // St Margaret's Hope
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lerwick-Kirkwall Route",
        operator: "NorthLink Ferries",
        duration: "5.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.1494, 60.1547], // Lerwick
            [-2.9597, 58.9811], // Kirkwall
          ],
        ],
      },
    },

    // More Scandinavian Internal Routes
    {
      type: "Feature",
      properties: {
        name: "Bodø-Moskenes Route",
        operator: "Torghatten Nord",
        duration: "3.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.4042, 67.2804], // Bodø
            [13.0167, 67.9167], // Moskenes (Lofoten)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bodø-Værøy Route",
        operator: "Torghatten Nord",
        duration: "3 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.4042, 67.2804], // Bodø
            [12.6833, 67.6667], // Værøy
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Skutvik-Svolvær Route",
        operator: "Torghatten Nord",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.0333, 68.0667], // Skutvik
            [14.5667, 68.2333], // Svolvær
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bognes-Lødingen Route",
        operator: "Torghatten Nord",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [16.1667, 68.2], // Bognes
            [15.9833, 68.4167], // Lødingen
          ],
        ],
      },
    },

    // More Baltic Internal Routes
    {
      type: "Feature",
      properties: {
        name: "Naantali-Långnäs Route",
        operator: "Finnlines",
        duration: "3.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [22.0, 60.4667], // Naantali
            [20.3, 60.1167], // Långnäs (Åland)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kapellskär-Långnäs Route",
        operator: "Finnlines",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [19.0772, 59.3639], // Kapellskär
            [20.3, 60.1167], // Långnäs
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Strömstad-Sandefjord Route",
        operator: "Color Line",
        duration: "2.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [11.1753, 58.9378], // Strömstad
            [10.2167, 59.1333], // Sandefjord
          ],
        ],
      },
    },

    // More Greek Islands (Ionian)
    {
      type: "Feature",
      properties: {
        name: "Igoumenitsa-Paxi Route",
        operator: "Various operators",
        duration: "1.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [20.8537, 39.665], // Igoumenitsa
            [20.2, 39.2], // Paxi
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Igoumenitsa-Lefkada Route",
        operator: "Various operators",
        duration: "3 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [20.8537, 39.665], // Igoumenitsa
            [20.7064, 38.8333], // Lefkada
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Astakos-Kefalonia Route",
        operator: "Ionian Ferries",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.0833, 38.55], // Astakos
            [20.5, 38.1833], // Kefalonia
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kefalonia-Zakynthos Route",
        operator: "Ionian Ferries",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [20.5, 38.1833], // Kefalonia
            [20.9, 37.7833], // Zakynthos
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kyllini-Zakynthos Route",
        operator: "Various operators",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.1333, 37.9333], // Kyllini
            [20.9, 37.7833], // Zakynthos
          ],
        ],
      },
    },

    // More Croatian Islands (Northern Adriatic)
    {
      type: "Feature",
      properties: {
        name: "Rijeka-Rab Route",
        operator: "Jadrolinija",
        duration: "1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.4419, 45.3269], // Rijeka
            [14.7583, 44.7583], // Rab
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Valbiska-Merag Route",
        operator: "Jadrolinija",
        duration: "1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.5167, 45.0667], // Valbiska (Krk)
            [14.7667, 44.95], // Merag (Cres)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Brestova-Porozina Route",
        operator: "Jadrolinija",
        duration: "20 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.3167, 45.1833], // Brestova
            [14.3333, 45.2167], // Porozina (Cres)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zadar-Silba Route",
        operator: "Jadrolinija",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2422, 44.1194], // Zadar
            [14.7, 44.3667], // Silba
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Zadar-Ist Route",
        operator: "Jadrolinija",
        duration: "3 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.2422, 44.1194], // Zadar
            [14.7833, 44.2833], // Ist
          ],
        ],
      },
    },

    // More Italian Minor Islands
    {
      type: "Feature",
      properties: {
        name: "Neapel-Ponza Route",
        operator: "SNAV / Laziomar",
        duration: "2.5 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [12.9667, 40.9], // Ponza
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Neapel-Ventotene Route",
        operator: "Laziomar",
        duration: "2 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [14.2681, 40.8518], // Neapel
            [13.4333, 40.8], // Ventotene
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Trapani-Favignana Route",
        operator: "Liberty Lines / Siremar",
        duration: "30 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.5367, 38.0181], // Trapani
            [12.3333, 37.9333], // Favignana
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Trapani-Levanzo Route",
        operator: "Liberty Lines / Siremar",
        duration: "20 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.5367, 38.0181], // Trapani
            [12.3667, 38.0167], // Levanzo
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Trapani-Marettimo Route",
        operator: "Liberty Lines / Siremar",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [12.5367, 38.0181], // Trapani
            [12.05, 37.9667], // Marettimo
          ],
        ],
      },
    },

    // More Spanish Minor Routes
    {
      type: "Feature",
      properties: {
        name: "Tarragona-Balearen Route",
        operator: "Grimaldi Lines",
        duration: "16 Stunden",
        frequency: "Wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.2444, 41.1189], // Tarragona
            [2.6502, 39.5696], // Palma
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Gandía-Ibiza Route",
        operator: "Baleària",
        duration: "4 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.1667, 38.9667], // Gandía
            [1.4206, 38.9067], // Ibiza
          ],
        ],
      },
    },

    // Denmark Internal Routes
    {
      type: "Feature",
      properties: {
        name: "Aarhus-Kalundborg Route",
        operator: "Mols-Linien",
        duration: "2.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.2134, 56.1629], // Aarhus
            [11.0886, 55.6794], // Kalundborg
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bøjden-Fynshav Route",
        operator: "Als-Linien",
        duration: "50 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.1167, 55.0833], // Bøjden
            [9.95, 55.0167], // Fynshav (Als)
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Spodsbjerg-Tårs Route",
        operator: "Færgen",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [10.8333, 54.8333], // Spodsbjerg (Langeland)
            [11.1167, 54.8667], // Tårs (Lolland)
          ],
        ],
      },
    },

    // More French Atlantic & Brittany Routes
    {
      type: "Feature",
      properties: {
        name: "Brest-Ouessant Route",
        operator: "Penn ar Bed",
        duration: "2.5 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-4.4861, 48.3833], // Brest
            [-5.0833, 48.4667], // Ouessant
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Quiberon-Belle-Île Route",
        operator: "Compagnie Océane",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.1167, 47.4833], // Quiberon
            [-3.15, 47.35], // Belle-Île-en-Mer
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lorient-Groix Route",
        operator: "Compagnie Océane",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-3.3667, 47.75], // Lorient
            [-3.45, 47.6333], // Groix
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "La Rochelle-Île de Ré Route",
        operator: "Régie Départementale",
        duration: "30 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-1.15, 46.1583], // La Rochelle
            [-1.3667, 46.2], // Île de Ré
          ],
        ],
      },
    },

    // More German North Sea Islands
    {
      type: "Feature",
      properties: {
        name: "Norddeich-Norderney Route",
        operator: "Reederei Norden-Frisia",
        duration: "1 Stunde",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.1583, 53.6333], // Norddeich
            [7.15, 53.7167], // Norderney
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Norddeich-Juist Route",
        operator: "Reederei Norden-Frisia",
        duration: "1.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.1583, 53.6333], // Norddeich
            [7.0167, 53.6833], // Juist
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Neuharlingersiel-Spiekeroog Route",
        operator: "Spiekeroog Fährschiff",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.7, 53.7], // Neuharlingersiel
            [7.7167, 53.75], // Spiekeroog
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Bensersiel-Langeoog Route",
        operator: "Schiffahrt der Insel Langeoog",
        duration: "30 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [7.5667, 53.6833], // Bensersiel
            [7.4833, 53.7333], // Langeoog
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dagebüll-Föhr Route",
        operator: "Wyker Dampfschiffs-Reederei",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.6833, 54.7333], // Dagebüll
            [8.4833, 54.7], // Wyk auf Föhr
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dagebüll-Amrum Route",
        operator: "Wyker Dampfschiffs-Reederei",
        duration: "1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [8.6833, 54.7333], // Dagebüll
            [8.3667, 54.6333], // Wittdün (Amrum)
          ],
        ],
      },
    },

    // More Dutch Wadden Islands
    {
      type: "Feature",
      properties: {
        name: "Harlingen-Vlieland Route",
        operator: "Doeksen",
        duration: "1.5 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.4194, 53.1742], // Harlingen
            [5.0667, 53.2917], // Vlieland
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Harlingen-Terschelling Route",
        operator: "Doeksen",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.4194, 53.1742], // Harlingen
            [5.2167, 53.3583], // Terschelling
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Holwerd-Ameland Route",
        operator: "Wagenborg Passagiersdiensten",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [5.9, 53.3667], // Holwerd
            [5.7667, 53.45], // Ameland
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Lauwersoog-Schiermonnikoog Route",
        operator: "Wagenborg Passagiersdiensten",
        duration: "45 Minuten",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [6.2, 53.4167], // Lauwersoog
            [6.1667, 53.4833], // Schiermonnikoog
          ],
        ],
      },
    },

    // Additional Portuguese Routes
    {
      type: "Feature",
      properties: {
        name: "Portimão-Funchal Route",
        operator: "Porto Santo Line",
        duration: "24 Stunden",
        frequency: "Wöchentlich (Sommer)",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-8.5375, 37.1946], // Portimão
            [-16.9093, 32.6507], // Funchal
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Funchal-Porto Santo Route",
        operator: "Porto Santo Line",
        duration: "2.5 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-16.9093, 32.6507], // Funchal (Madeira)
            [-16.3167, 33.0667], // Porto Santo
          ],
        ],
      },
    },

    // Additional Faroe Islands Routes
    {
      type: "Feature",
      properties: {
        name: "Tórshavn-Suðuroy Route",
        operator: "Strandfaraskip Landsins",
        duration: "2 Stunden",
        frequency: "Mehrmals täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-6.7683, 62.0097], // Tórshavn
            [-6.8167, 61.5333], // Tvøroyri (Suðuroy)
          ],
        ],
      },
    },

    // Fehlende Routen aus der Tabelle:

    // 1. Felixstowe-Rotterdam
    {
      type: "Feature",
      properties: {
        name: "Felixstowe-Rotterdam Route",
        operator: "Stena Line",
        duration: "10 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.295, 51.9617], // Felixstowe
            [4.4792, 51.9225], // Rotterdam
          ],
        ],
      },
    },

    // 2. Purfleet-Rotterdam
    {
      type: "Feature",
      properties: {
        name: "Purfleet-Rotterdam Route",
        operator: "DFDS",
        duration: "12 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [0.2333, 51.4833], // Purfleet
            [4.4792, 51.9225], // Rotterdam
          ],
        ],
      },
    },

    // 3. Killingholme-Rotterdam
    {
      type: "Feature",
      properties: {
        name: "Killingholme-Rotterdam Route",
        operator: "P&O Ferries",
        duration: "11 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-0.2667, 53.5833], // Killingholme
            [4.4792, 51.9225], // Rotterdam
          ],
        ],
      },
    },

    // 4. Heysham-Belfast
    {
      type: "Feature",
      properties: {
        name: "Heysham-Belfast Route",
        operator: "Stena Line",
        duration: "8 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [-2.8686, 54.0689], // Heysham
            [-5.93, 54.5964], // Belfast
          ],
        ],
      },
    },

    // 5. Uusikaupunki-Travemünde
    {
      type: "Feature",
      properties: {
        name: "Uusikaupunki-Travemünde Route",
        operator: "Finnlines",
        duration: "9 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [21.4, 60.8], // Uusikaupunki
            [10.8786, 53.9575], // Travemünde
          ],
        ],
      },
    },

    // 6. Helsinki-Lübeck
    {
      type: "Feature",
      properties: {
        name: "Helsinki-Lübeck Route",
        operator: "Finnlines",
        duration: "28 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [24.9384, 60.1699], // Helsinki
            [10.6869, 53.8656], // Lübeck
          ],
        ],
      },
    },

    // 7. Nynäshamn-Rostock
    {
      type: "Feature",
      properties: {
        name: "Nynäshamn-Rostock Route",
        operator: "Destination Gotland",
        duration: "10 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [17.0078, 58.5986], // Nynäshamn
            [12.0991, 54.0924], // Rostock
          ],
        ],
      },
    },

    // 8. Visby-Rostock
    {
      type: "Feature",
      properties: {
        name: "Visby-Rostock Route",
        operator: "Destination Gotland",
        duration: "6 Stunden",
        frequency: "Saisonal",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [18.3, 57.6333], // Visby
            [12.0991, 54.0924], // Rostock
          ],
        ],
      },
    },

    // 9. Poti-Varna
    {
      type: "Feature",
      properties: {
        name: "Poti-Varna Route",
        operator: "Navigation Maritime Bulgare",
        duration: "42 Stunden",
        frequency: "Mehrmals monatlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [41.6667, 42.1667], // Poti
            [27.9161, 43.2047], // Varna
          ],
        ],
      },
    },

    // 10. Catania-Malta (bereits als Catania-Valletta vorhanden, aber ergänze explizite Route)
    {
      type: "Feature",
      properties: {
        name: "Catania-Malta (Valletta) Route",
        operator: "Virtu Ferries",
        duration: "4 Stunden",
        frequency: "Mehrmals wöchentlich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [15.083, 37.5079], // Catania
            [14.5146, 35.8989], // Valletta
          ],
        ],
      },
    },

    // 13. Harwich-Rotterdam (zusätzlich zu Hoek van Holland)
    {
      type: "Feature",
      properties: {
        name: "Harwich-Rotterdam Route",
        operator: "Stena Line",
        duration: "10 Stunden",
        frequency: "Täglich",
      },
      geometry: {
        type: "MultiLineString",
        coordinates: [
          [
            [1.2833, 51.9469], // Harwich
            [4.4792, 51.9225], // Rotterdam
          ],
        ],
      },
    },

    // Additional Routes can be added here
  ],
};

export default routesData;
export {ferryRoutesGeoJSON};
